webpackJsonp([6],{

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEvent = exports.formatChildren = exports.EventNames = void 0;
var react_1 = __importDefault(__webpack_require__(0));
var EventNames;
(function (EventNames) {
    EventNames["itemClicked"] = "Item Clicked";
    EventNames["itemExpanded"] = "Item Expanded";
    EventNames["modalFired"] = "Modal Fired";
    EventNames["errorPresented"] = "Error Presented";
})(EventNames || (exports.EventNames = EventNames = {}));
var getDisplayName = function (child) {
    if (typeof child !== 'object' || child === null) {
        return null;
    }
    if ('type' in child &&
        typeof child.type === 'object' &&
        child.type !== null) {
        if ('displayName' in child.type &&
            typeof child.type.displayName === 'string') {
            return child.type.displayName;
        }
        if ('type' in child.type &&
            typeof child.type.type === 'object' &&
            child.type.type !== null &&
            'displayName' in child.type.type &&
            typeof child.type.type.displayName === 'string') {
            return child.type.type.displayName;
        }
    }
    return null;
};
var extractChild = function (child) {
    switch (typeof child) {
        case 'string':
        case 'number':
            return child;
        case 'object':
            if (child !== null && 'type' in child && typeof child.type === 'object') {
                var displayName = getDisplayName(child);
                if (displayName) {
                    // If the child has a displayName that can be used, format that value
                    return displayName;
                }
            }
            if (child !== null && 'props' in child && 'children' in child.props) {
                // If the child has nested children, format those as well
                return child.props.children;
            }
            return null;
        default:
            return null;
    }
};
var formatChildren = function (children) {
    var formattedChildren = [];
    var childArray = react_1.default.Children.toArray(children);
    switch (typeof children) {
        case 'string':
            return children;
        case 'number':
            return children.toString();
        case 'object':
            for (var i = 0; i < childArray.length; i += 1) {
                var child = childArray[i];
                var extractedChild = extractChild(child);
                formattedChildren.push((0, exports.formatChildren)(extractedChild));
            }
            // Remove falsey values (0, null, undefined, false, '') from array before joining
            return formattedChildren.filter(function (item) { return item; }).join(' ');
        default:
            return '';
    }
};
exports.formatChildren = formatChildren;
var stripProps = function (props) {
    var strippedProps = {
        category: props.category,
        businessId: props.businessId,
        businessUuid: props.businessUuid,
        spId: props.spId,
        jobId: props.jobId,
        searchSessionId: props.searchSessionId,
        searchRefinementId: props.searchRefinementId,
        searchPostalCode: props.searchPostalCode,
        homeAdvisorSessionId: props.homeAdvisorSessionId,
        entryMpTaskId: props.entryMpTaskId,
        currentMpTaskId: props.currentMpTaskId,
    };
    // Removes keys with undefined and null values
    var filteredEntries = Object.entries(strippedProps).filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], value = _b[1];
        return value !== undefined;
    });
    return Object.fromEntries(filteredEntries);
};
var getActivityLocationMetaTag = function () {
    var metaTag = document.querySelector('meta[name="activityLocation"]');
    if (metaTag instanceof HTMLMetaElement && metaTag.content) {
        return metaTag.content;
    }
    return null;
};
var buildEventSpecificProps = function (options) {
    var children = options.children, trackingProps = options.trackingProps, eventName = options.eventName, className = options.className;
    var props = {};
    props.activityLocation =
        getActivityLocationMetaTag() || trackingProps.pageName;
    switch (eventName) {
        case EventNames.itemClicked: {
            var description = trackingProps.useClassName && className
                ? className
                : (0, exports.formatChildren)(children);
            props.description = description;
            break;
        }
        case EventNames.itemExpanded: {
            props.description = trackingProps.componentTitle;
            break;
        }
        case EventNames.modalFired: {
            props.modalName = trackingProps.componentTitle;
            props.component = 'modal';
            break;
        }
        case EventNames.errorPresented: {
            props.errorString = trackingProps.errorString;
            props.errorInfo = trackingProps.errorInfo;
            break;
        }
        default: {
            break;
        }
    }
    if (trackingProps.description) {
        props.description = trackingProps.description;
    }
    return props;
};
var fetchTrackingContextProps = function (context) {
    if (!context) {
        return {};
    }
    // Separate updateContext function out from the rest of the context
    var updateContext = context.updateContext, trackingContextProps = __rest(context, ["updateContext"]);
    return trackingContextProps;
};
var fetchCookieProps = function () {
    var cookieProps = {};
    var propToCookieMapping = {
        homeAdvisorSessionId: 'sess_log=',
    };
    Object.keys(propToCookieMapping).forEach(function (prop) {
        var cookieKey = propToCookieMapping[prop];
        var cookie = decodeURIComponent(document.cookie)
            .split(';')
            .map(function (item) { return item.trim(); })
            .find(function (item) { return item.startsWith(cookieKey); });
        if (cookie !== undefined) {
            var cookieValue = cookie.substring(cookieKey.length);
            cookieProps[prop] = decodeURIComponent(cookieValue);
        }
    });
    return cookieProps;
};
var extractCustomProps = function (trackingProps) {
    var customProps = [
        trackingProps.customProp1,
        trackingProps.customProp2,
        trackingProps.customProp3,
        trackingProps.customProp4,
        trackingProps.customProp5,
        trackingProps.customProp6,
        trackingProps.customProp7,
        trackingProps.customProp8,
        trackingProps.customProp9,
        trackingProps.customProp10,
    ];
    var strippedCustomProps = customProps.flatMap(function (prop) {
        return prop !== undefined ? [prop] : [null];
    });
    return strippedCustomProps;
};
var formatCustomProps = function (trackingProps) {
    var _a, _b;
    var customProps = extractCustomProps(trackingProps);
    var formattedProps = {};
    for (var i = 0; i < customProps.length; i += 1) {
        var customProp = customProps[i];
        // Only format customProp if both value and description are present to prevent orphaned customProps.
        if ((customProp === null || customProp === void 0 ? void 0 : customProp.value) && customProp.description) {
            var customPropKey = "customProp".concat(i + 1);
            formattedProps[customPropKey] = (_a = customProps[i]) === null || _a === void 0 ? void 0 : _a.value;
            var customPropDescriptionKey = "".concat(customPropKey, "Description");
            formattedProps[customPropDescriptionKey] = (_b = customProps[i]) === null || _b === void 0 ? void 0 : _b.description;
        }
    }
    return formattedProps;
};
/**
 * Triggers a Segment track event with predefined properties:
 *  Item Clicked:
 *    {
 *      description,
 *      activityLocation,
 *      category (optional),
 *      businessId (optional),
 *      businessUuid (optional),
 *      spId (optional),
 *      jobId (optional),
 *      searchSessionId (optional),
 *      searchRefinementId (optional),
 *      searchPostalCode (optional),
 *      homeAdvisorSessionId (optional),
 *      entryMpTaskId (optional),
 *      currentMpTaskId (optional),
 *      customProp1-10 (10 optional custom properties)
 *      customProp1-10Description (descriptions for custom properties)
 *    }
 *
 *  Item Expanded:
 *    {
 *      description,
 *      activityLocation,
 *      category (optional),
 *      businessId (optional),
 *      businessUuid (optional),
 *      spId (optional),
 *      jobId (optional),
 *      searchSessionId (optional),
 *      searchRefinementId (optional),
 *      searchPostalCode (optional),
 *      homeAdvisorSessionId (optional),
 *      entryMpTaskId (optional),
 *      currentMpTaskId (optional),
 *      customProp1-10 (10 optional custom properties)
 *      customProp1-10Description (descriptions for custom properties)

 *    }
 *
 *  Modal Fired:
 *    {
 *      modalName,
 *      activityLocation,
 *      component,
 *      category (optional),
 *      businessId (optional),
 *      businessUuid (optional),
 *      spId (optional),
 *      jobId (optional),
 *      searchSessionId (optional),
 *      searchRefinementId (optional),
 *      searchPostalCode (optional),
 *      homeAdvisorSessionId (optional),
 *      entryMpTaskId (optional),
 *      currentMpTaskId (optional),
 *      customProp1-10 (10 optional custom properties)
 *      customProp1-10Description (descriptions for custom properties)
 *    }
 *
 *  Error Presented:
 *    {
 *      activityLocation,
 *      errorString,
 *      errorInfo (optional),
*       category (optional),
 *      businessId (optional),
 *      businessUuid (optional),
 *      spId (optional),
 *      jobId (optional),
 *      searchSessionId (optional),
 *      searchRefinementId (optional),
 *      searchPostalCode (optional),
 *      homeAdvisorSessionId (optional),
 *      entryMpTaskId (optional),
 *      currentMpTaskId (optional),
 *      customProp1-10 (10 optional custom properties)
 *      customProp1-10Description (descriptions for custom properties)
 *    }
 *
 * @param children React elements to be used to compose the element description
 * @param trackingProps Props from the element that are specific to tracking
 * @param eventName Name of the event to be fired: Item Clicked or Modal Shown
 * @param className (Optional) class name of the element. Can be used as a default itemDescription
 */
var trackEvent = function (options) {
    var eventName = options.eventName, trackingContext = options.trackingContext, trackingMetadata = options.trackingMetadata, trackingProps = options.trackingProps;
    var analytics = typeof window !== 'undefined' ? window.analytics : undefined;
    if (analytics && trackingProps.enableTracking) {
        var eventProps = buildEventSpecificProps(options);
        var cookieProps = fetchCookieProps();
        var trackingContextProps = fetchTrackingContextProps(trackingContext);
        var formattedCustomProps = formatCustomProps(trackingProps);
        var properties = __assign(__assign(__assign(__assign(__assign({}, eventProps), cookieProps), trackingContextProps), stripProps(trackingProps)), formattedCustomProps);
        var context = trackingMetadata === undefined ? {} : { designSystem: trackingMetadata };
        analytics.track(eventName, properties, context);
    }
};
exports.trackEvent = trackEvent;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(5797);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 2536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keymirror___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_keymirror__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_keymirror___default()(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createActionKeys('UPDATE_BUSINESS_DESCRIPTION'))));

/***/ }),

/***/ 2552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(__webpack_require__(0));
var clsx_1 = __importDefault(__webpack_require__(499));
var Button_module_css_1 = __importDefault(__webpack_require__(5781));
var HeadlessButton_1 = __webpack_require__(2553);
exports.Button = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? 'regular' : _d, props = __rest(_a, ["variant", "size"]);
    var classes = (0, clsx_1.default)(props.className, Button_module_css_1.default.btn, (_b = {},
        _b[Button_module_css_1.default.fullBleed] = variant === 'fullBleed',
        _b[Button_module_css_1.default.primary] = variant === 'primary',
        _b[Button_module_css_1.default.secondary] = variant === 'secondary',
        _b[Button_module_css_1.default.secondaryNeutral] = variant === 'secondaryNeutral',
        _b[Button_module_css_1.default.tertiaryNeutral] = variant === 'tertiaryNeutral',
        _b[Button_module_css_1.default.tertiary] = variant === 'tertiary',
        _b[Button_module_css_1.default.link] = variant === 'link',
        _b[Button_module_css_1.default.small] = size === 'small',
        _b[Button_module_css_1.default.secondaryPurple] = variant === 'secondaryPurple',
        _b[Button_module_css_1.default.secondaryHeart] = variant === 'secondaryHeart',
        _b[Button_module_css_1.default['northstar-primary']] = variant === 'northstarPrimary',
        _b[Button_module_css_1.default['northstar-secondary']] = variant === 'northstarSecondary',
        _b[Button_module_css_1.default['northstar-primary-heart']] = variant === 'northstarPrimaryHeart',
        _b[Button_module_css_1.default['northstar-secondary-heart']] = variant === 'northstarSecondaryHeart',
        _b));
    return (react_1.default.createElement(HeadlessButton_1.HeadlessButton, __assign({ ref: ref }, props, { trackingClassName: props.className, className: classes })));
});
exports.Button.displayName = 'Button';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vQnV0dG9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQ0EsZ0RBQTBCO0FBQzFCLDhDQUF3QjtBQUN4QiwwRUFBc0M7QUFDdEMsbURBQWtEO0FBMkJyQyxRQUFBLE1BQU0sR0FBRyxlQUFLLENBQUMsVUFBVSxDQUNwQyxVQUNFLEVBQWdFLEVBQ2hFLEdBQXdEOztJQUR0RCxJQUFBLGVBQW1CLEVBQW5CLE9BQU8sbUJBQUcsU0FBUyxLQUFBLEVBQUUsWUFBZ0IsRUFBaEIsSUFBSSxtQkFBRyxTQUFTLEtBQUEsRUFBSyxLQUFLLGNBQWpELG1CQUFtRCxDQUFGO0lBR2pELElBQU0sT0FBTyxHQUFHLElBQUEsY0FBSSxFQUFDLEtBQUssQ0FBQyxTQUFTLEVBQUUsMkJBQUcsQ0FBQyxHQUFHO1FBQzNDLEdBQUMsMkJBQUcsQ0FBQyxTQUFTLElBQUcsT0FBTyxLQUFLLFdBQVc7UUFDeEMsR0FBQywyQkFBRyxDQUFDLE9BQU8sSUFBRyxPQUFPLEtBQUssU0FBUztRQUNwQyxHQUFDLDJCQUFHLENBQUMsU0FBUyxJQUFHLE9BQU8sS0FBSyxXQUFXO1FBQ3hDLEdBQUMsMkJBQUcsQ0FBQyxnQkFBZ0IsSUFBRyxPQUFPLEtBQUssa0JBQWtCO1FBQ3RELEdBQUMsMkJBQUcsQ0FBQyxlQUFlLElBQUcsT0FBTyxLQUFLLGlCQUFpQjtRQUNwRCxHQUFDLDJCQUFHLENBQUMsUUFBUSxJQUFHLE9BQU8sS0FBSyxVQUFVO1FBQ3RDLEdBQUMsMkJBQUcsQ0FBQyxJQUFJLElBQUcsT0FBTyxLQUFLLE1BQU07UUFDOUIsR0FBQywyQkFBRyxDQUFDLEtBQUssSUFBRyxJQUFJLEtBQUssT0FBTztRQUM3QixHQUFDLDJCQUFHLENBQUMsZUFBZSxJQUFHLE9BQU8sS0FBSyxpQkFBaUI7UUFDcEQsR0FBQywyQkFBRyxDQUFDLGNBQWMsSUFBRyxPQUFPLEtBQUssZ0JBQWdCO1FBQ2xELEdBQUMsMkJBQUcsQ0FBQyxtQkFBbUIsQ0FBQyxJQUFHLE9BQU8sS0FBSyxrQkFBa0I7UUFDMUQsR0FBQywyQkFBRyxDQUFDLHFCQUFxQixDQUFDLElBQUcsT0FBTyxLQUFLLG9CQUFvQjtRQUM5RCxHQUFDLDJCQUFHLENBQUMseUJBQXlCLENBQUMsSUFBRyxPQUFPLEtBQUssdUJBQXVCO1FBQ3JFLEdBQUMsMkJBQUcsQ0FBQywyQkFBMkIsQ0FBQyxJQUFHLE9BQU8sS0FBSyx5QkFBeUI7WUFDekUsQ0FBQztJQUVILE9BQU8sQ0FDTCw4QkFBQywrQkFBYyxhQUNiLEdBQUcsRUFBRSxHQUFHLElBQ0osS0FBSyxJQUNULGlCQUFpQixFQUFFLEtBQUssQ0FBQyxTQUFTLEVBQ2xDLFNBQVMsRUFBRSxPQUFPLElBQ2xCLENBQ0gsQ0FBQztBQUNKLENBQUMsQ0FDRixDQUFDO0FBRUYsY0FBTSxDQUFDLFdBQVcsR0FBRyxRQUFRLENBQUMifQ==

/***/ }),

/***/ 2553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlessButton = void 0;
var react_1 = __importDefault(__webpack_require__(0));
var react_utils_1 = __webpack_require__(5782);
var metadata_1 = __webpack_require__(5806);
var extractName = function (children) {
    if (typeof children === 'string') {
        return children;
    }
    if (Array.isArray(children)) {
        var name_1 = children
            .map(function (child) { return (typeof child === 'string' ? child : ''); })
            .filter(function (child) { return child !== ''; })
            .join(' ')
            .trim();
        return name_1;
    }
    return undefined;
};
exports.HeadlessButton = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.trackingProps, trackingProps = _c === void 0 ? {
        enableTracking: false,
        pageName: 'Default Page Name',
        useClassName: false,
    } : _c, _d = _a.component, component = _d === void 0 ? 'button' : _d, trackingClassName = _a.trackingClassName, props = __rest(_a, ["trackingProps", "component", "trackingClassName"]);
    var COMPONENT_METADATA = {
        language: 'typescript',
        version: metadata_1.VERSION,
        name: metadata_1.NAME,
    };
    var trackingContext = (0, react_utils_1.useTrackingContext)();
    var trackClick = function (event) {
        if (props.onClick) {
            props.onClick(event);
        }
        (0, react_utils_1.trackEvent)({
            children: props.children,
            trackingProps: trackingProps,
            eventName: react_utils_1.EventNames.itemClicked,
            className: trackingClassName,
            trackingMetadata: COMPONENT_METADATA,
            trackingContext: trackingContext,
        });
    };
    if (component === 'a') {
        var _e = props, href = _e.href, rest_1 = __rest(_e, ["href"]);
        var internalRef_1 = ref;
        return (react_1.default.createElement("a", __assign({ "data-testid": "angi_button", href: href }, rest_1, { ref: internalRef_1, onClick: trackClick }), props.children));
    }
    var internalRef = ref;
    var rest = __rest(props, []);
    var name = (_b = rest.name) !== null && _b !== void 0 ? _b : extractName(rest.children);
    return (react_1.default.createElement("button", __assign({ name: name, type: "button", "data-testid": "angi_button" }, rest, { ref: internalRef, onClick: trackClick }), props.children));
});
exports.HeadlessButton.displayName = 'HeadlessButton';
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 2554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetTimeout = void 0;
var react_1 = __webpack_require__(0);
/*
 * Returns a function with the same API as setTimeout, but which automatically clears timers if the component unmounts.
 * This helps to avoid state updates on unmounted components which produce memory leak warnings.
 *
 * Only use this when you need to clear the timer when the component unmounts. There may be cases where this is not necessary!
 */
var useSetTimeout = function () {
    var ref = (0, react_1.useRef)(new Set());
    (0, react_1.useEffect)(function () { return function () { return ref.current.forEach(clearTimeout); }; }, []);
    return (0, react_1.useCallback)(function (callback, ms) {
        var timerId = setTimeout(function () {
            callback();
            ref.current.delete(timerId);
        }, ms);
        ref.current.add(timerId);
        return timerId;
    }, []);
};
exports.useSetTimeout = useSetTimeout;
exports.default = exports.useSetTimeout;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlU2V0VGltZW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3VzZVNldFRpbWVvdXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsK0JBQXVEO0FBRXZEOzs7OztHQUtHO0FBQ0ksSUFBTSxhQUFhLEdBQUc7SUFDM0IsSUFBTSxHQUFHLEdBQUcsSUFBQSxjQUFNLEVBQXFDLElBQUksR0FBRyxFQUFFLENBQUMsQ0FBQztJQUNsRSxJQUFBLGlCQUFTLEVBQUMsY0FBTSxPQUFBLGNBQU0sT0FBQSxHQUFHLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUFZLENBQUMsRUFBakMsQ0FBaUMsRUFBdkMsQ0FBdUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUU3RCxPQUFPLElBQUEsbUJBQVcsRUFDaEIsVUFBQyxRQUE4QixFQUFFLEVBQXVCO1FBQ3RELElBQU0sT0FBTyxHQUFHLFVBQVUsQ0FBQztZQUN6QixRQUFRLEVBQUUsQ0FBQztZQUNYLEdBQUcsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBQzlCLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUNQLEdBQUcsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1FBRXpCLE9BQU8sT0FBTyxDQUFDO0lBQ2pCLENBQUMsRUFDRCxFQUFFLENBQ0gsQ0FBQztBQUNKLENBQUMsQ0FBQztBQWhCVyxRQUFBLGFBQWEsaUJBZ0J4QjtBQUVGLGtCQUFlLHFCQUFhLENBQUMifQ==

/***/ }),

/***/ 2555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrap = Wrap;
var react_1 = __importDefault(__webpack_require__(0));
function Wrap(_a) {
    var wrapper = _a.wrapper, children = _a.children;
    return react_1.default.createElement(react_1.default.Fragment, null, wrapper ? react_1.default.cloneElement(wrapper, { children: children }) : children);
}
exports.default = Wrap;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV3JhcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL1dyYXAudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBT0Esb0JBRUM7QUFURCxnREFBMEI7QUFPMUIsU0FBZ0IsSUFBSSxDQUFDLEVBQWdDO1FBQTlCLE9BQU8sYUFBQSxFQUFFLFFBQVEsY0FBQTtJQUN0QyxPQUFPLDhEQUFHLE9BQU8sQ0FBQyxDQUFDLENBQUMsZUFBSyxDQUFDLFlBQVksQ0FBQyxPQUFPLEVBQUUsRUFBRSxRQUFRLFVBQUEsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBSSxDQUFDO0FBQy9FLENBQUM7QUFFRCxrQkFBZSxJQUFJLENBQUMifQ==

/***/ }),

/***/ 2556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTrackingContext = exports.TrackingContextProvider = void 0;
var react_1 = __importStar(__webpack_require__(0));
var TrackingContext = (0, react_1.createContext)({});
var TrackingContextProvider = function (_a) {
    var children = _a.children;
    var _b = __read((0, react_1.useState)({}), 2), contextState = _b[0], setContextState = _b[1];
    var updateContext = function (newValues) {
        setContextState(function (prev) { return (__assign(__assign({}, prev), newValues)); });
    };
    // Memoize the context value to prevent unnecessary re-renders
    var memoizedContextValue = (0, react_1.useMemo)(function () { return (__assign(__assign({}, contextState), { updateContext: updateContext })); }, [contextState]);
    return (react_1.default.createElement(TrackingContext.Provider, { value: memoizedContextValue }, children));
};
exports.TrackingContextProvider = TrackingContextProvider;
var useTrackingContext = function () {
    var context = (0, react_1.useContext)(TrackingContext);
    return context;
};
exports.useTrackingContext = useTrackingContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2tpbmdDb250ZXh0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vdHJhY2tpbmdDb250ZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBNEU7QUFRNUUsSUFBTSxlQUFlLEdBQUcsSUFBQSxxQkFBYSxFQUFzQixFQUFFLENBQUMsQ0FBQztBQUV4RCxJQUFNLHVCQUF1QixHQUFzQyxVQUFDLEVBRTFFO1FBREMsUUFBUSxjQUFBO0lBRUYsSUFBQSxLQUFBLE9BQWtDLElBQUEsZ0JBQVEsRUFBQyxFQUFFLENBQUMsSUFBQSxFQUE3QyxZQUFZLFFBQUEsRUFBRSxlQUFlLFFBQWdCLENBQUM7SUFFckQsSUFBTSxhQUFhLEdBQUcsVUFBQyxTQUF3QztRQUM3RCxlQUFlLENBQUMsVUFBQyxJQUFJLElBQUssT0FBQSx1QkFBTSxJQUFJLEdBQUssU0FBUyxFQUFHLEVBQTNCLENBQTJCLENBQUMsQ0FBQztJQUN6RCxDQUFDLENBQUM7SUFFRiw4REFBOEQ7SUFDOUQsSUFBTSxvQkFBb0IsR0FBRyxJQUFBLGVBQU8sRUFDbEMsY0FBTSxPQUFBLHVCQUFNLFlBQVksS0FBRSxhQUFhLGVBQUEsSUFBRyxFQUFwQyxDQUFvQyxFQUMxQyxDQUFDLFlBQVksQ0FBQyxDQUNmLENBQUM7SUFFRixPQUFPLENBQ0wsOEJBQUMsZUFBZSxDQUFDLFFBQVEsSUFBQyxLQUFLLEVBQUUsb0JBQW9CLElBQ2xELFFBQVEsQ0FDZ0IsQ0FDNUIsQ0FBQztBQUNKLENBQUMsQ0FBQztBQXBCVyxRQUFBLHVCQUF1QiwyQkFvQmxDO0FBRUssSUFBTSxrQkFBa0IsR0FBRztJQUNoQyxJQUFNLE9BQU8sR0FBRyxJQUFBLGtCQUFVLEVBQUMsZUFBZSxDQUFDLENBQUM7SUFFNUMsT0FBTyxPQUFPLENBQUM7QUFDakIsQ0FBQyxDQUFDO0FBSlcsUUFBQSxrQkFBa0Isc0JBSTdCIn0=

/***/ }),

/***/ 2557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export Options */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Options_scss__ = __webpack_require__(5813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Options_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Options_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_BusinessListConstants__ = __webpack_require__(2558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_common_businessList_businessListActions__ = __webpack_require__(727);








var _strong;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}

/* eslint-disable no-nested-ternary */

/* eslint-disable react/no-did-update-set-state */

/* eslint-disable react/no-did-mount-set-state */











var Options = /*#__PURE__*/function (_React$Component) {
  function Options(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Options);

    _this2 = _callSuper(this, Options, [props]);

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "handleRadioChange", function (e) {
      _this2.props.setSortBy(e.currentTarget.value);
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "handleFilter", function (e) {
      _this2.sendFilterAndSortEventsToSegment();

      var _this2$props = _this2.props,
          getServiceProviders = _this2$props.getServiceProviders,
          serviceProviders = _this2$props.serviceProviders,
          closeFilter = _this2$props.closeFilter,
          sortByValue = _this2$props.sortByValue;
      if (closeFilter) closeFilter();

      var sortedBy = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(serviceProviders, 'response.sortedBy', 'name');

      if (sortByValue !== sortedBy) {
        getServiceProviders({
          sortBy: sortByValue,
          // start back at the new beginning of result set if a sort or filter is applied
          offset: __WEBPACK_IMPORTED_MODULE_16__common_BusinessListConstants__["a" /* DEFAULT_OFFSET */],
          limit: __WEBPACK_IMPORTED_MODULE_16__common_BusinessListConstants__["b" /* PROS_PER_PAGE */]
        });
      }
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "sendToTracker", function (description) {
      __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__["tracker"].track('Item Clicked', _objectSpread({}, {
        activityLocation: 'SP : Business List',
        description: description
      }));
    });

    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "sendSortByEvent", function (sortByValue) {
      switch (sortByValue) {
        case 'ratings':
          _this2.sendToTracker('Clicks on customer rating sort by');

          break;

        case 'reviews':
          _this2.sendToTracker('Clicks on total reviews sort by');

          break;

        default:
          _this2.sendToTracker('Clicks on business name sort by');

          break;
      }
    });

    _this2.handleRadioChange = _this2.handleRadioChange.bind(_this2);
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Options, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Options, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var serviceProviders = this.props.serviceProviders;

      var sortedBy = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(serviceProviders, 'response.sortedBy', 'name');

      this.props.setSortBy(sortedBy);
    }
  }, {
    key: "sendFilterAndSortEventsToSegment",
    value: function sendFilterAndSortEventsToSegment() {
      var sortByValue = this.props.sortByValue;
      this.sendSortByEvent(sortByValue);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        className: "businesslist-options"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        className: "filter-options"
      }, _strong || (_strong = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, " Sort by ")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default.a, {
        id: "filterOptionsSortByName",
        value: "name",
        type: "radio",
        role: "radio",
        label: "Business name (A-Z)",
        name: "filterOptionsSortBy",
        onClick: function onClick(e) {
          return _this3.handleRadioChange(e);
        },
        defaultChecked: true,
        checked: this.props.sortByValue === 'name'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default.a, {
        id: "filterOptionsSortByRating",
        value: "ratings",
        type: "radio",
        role: "radio",
        label: "Customer rating (high to low)",
        name: "filterOptionsSortBy",
        onClick: function onClick(e) {
          return _this3.handleRadioChange(e);
        },
        checked: this.props.sortByValue === 'ratings'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Input___default.a, {
        id: "filterOptionsSortByReview",
        value: "reviews",
        type: "radio",
        role: "radio",
        label: "Total reviews (high to low)",
        name: "filterOptionsSortBy",
        onClick: function onClick(e) {
          return _this3.handleRadioChange(e);
        },
        checked: this.props.sortByValue === 'reviews'
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", {
        className: "filter-options-apply text-center"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Button___default.a, {
        id: "filter-options-apply-button",
        className: "apply-button",
        onClick: function onClick() {
          return _this3.handleFilter();
        },
        bsSize: "small",
        bsStyle: "default-office",
        flat: true
      }, "APPLY"))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_8_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function (state) {
  return {
    serviceProviders: state.businessList.getServiceProviders
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_17__app_common_businessList_businessListActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default.a)(Options)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 2558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROS_PER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_OFFSET; });
var PROS_PER_PAGE = 10;
var DEFAULT_OFFSET = 0;

/***/ }),

/***/ 2559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_touch_device__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_touch_device___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_touch_device__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BusinessCard_scss__ = __webpack_require__(5815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BusinessCard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__BusinessCard_scss__);
var _div, _Col;










var usingTouchDevice = __WEBPACK_IMPORTED_MODULE_2_is_touch_device___default()();

var BusinessCard = function BusinessCard(props) {
  var _props$sp = props.sp,
      proType = _props$sp.proType,
      _props$sp$starRating = _props$sp.starRating,
      starRating = _props$sp$starRating === void 0 ? 0 : _props$sp$starRating,
      displayReviewCount = _props$sp.displayReviewCount,
      primaryAddress = _props$sp.primaryAddress,
      name = _props$sp.name,
      id = _props$sp.id,
      activityCount = _props$sp.activityCount,
      accessEndsAt = _props$sp.accessEndsAt,
      packageInfo = _props$sp.packageInfo,
      onCardClicked = props.onCardClicked,
      productInfoFeatureFlag = props.productInfoFeatureFlag;

  var onBusinessCardClicked = function onBusinessCardClicked(e) {
    e.stopPropagation();
    onCardClicked(id, proType);
  };

  var formatToLocalTime = function formatToLocalTime(utcDateTimeString) {
    var date = new Date(utcDateTimeString);
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["Track"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    className: "business-card",
    id: "sp-business-card",
    onClick: onBusinessCardClicked,
    spid: id
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 7,
    md: 11,
    sm: 11,
    xs: 10
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-details"
  }, productInfoFeatureFlag && packageInfo && packageInfo.productType === 'Subscription' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-pills"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-product-type"
  }, packageInfo.productType)) : productInfoFeatureFlag && proType === 'Ads' || !productInfoFeatureFlag ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-pills"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-source"
  }, "Angi ".concat(proType)), proType === 'Leads' && accessEndsAt && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-delegation-expiration"
  }, "Delegation expires at ".concat(formatToLocalTime(accessEndsAt)))) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "h4 business-name",
    title: name
  }, name), primaryAddress ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4", {
    className: "h4 business-region",
    title: primaryAddress.city !== undefined ? primaryAddress.city.name : ''
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-city"
  }, primaryAddress.city !== undefined ? primaryAddress.city.name : ''), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, primaryAddress.region !== undefined ? ", ".concat(primaryAddress.region.name) : '')) : null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 2,
    mdHidden: true,
    smHidden: true,
    xsHidden: true
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('business-info', {
      gray: starRating === 0
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar___default.a, {
    rating: starRating,
    starSize: "1.2em",
    ratingFontSize: "14px"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "rating-value"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "(", displayReviewCount, ")")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 2,
    mdHidden: true,
    smHidden: true,
    xsHidden: true,
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({
      'hide-on-hover': !usingTouchDevice
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info spid"
  }, "ID: ", id)), activityCount > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 1,
    mdHidden: true,
    smHidden: true,
    xsHidden: true,
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({
      'hide-on-hover': !usingTouchDevice
    })
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info status"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon-circle"
  })))), activityCount > 0 && (_Col || (_Col = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lgHidden: true,
    md: 1,
    sm: 1,
    xs: 2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info status"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
    className: "icon icon-circle"
  }))))), !usingTouchDevice && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    lg: 3,
    mdHidden: true,
    smHidden: true,
    xsHidden: true,
    className: "show-on-hover"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Button___default.a, {
    id: "card-select-btn",
    className: "choose-btn",
    onClick: onBusinessCardClicked
  }, "Choose")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    md: 3,
    lgHidden: true,
    sm: 4,
    xs: 6
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('business-info sm-view', {
      gray: starRating === 0
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_angieslist_react_components_lib_RatingDisplaySingleStar___default.a, {
    rating: starRating,
    starSize: "1.2em",
    ratingFontSize: "14px"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "rating-value"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "(", displayReviewCount, ")")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Col___default.a, {
    md: 3,
    lgHidden: true,
    sm: 4,
    xs: 6,
    smOffset: 4
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-info spid sm-view"
  }, "ID: ", id)))));
};

/* harmony default export */ __webpack_exports__["a"] = (BusinessCard);

/***/ }),

/***/ 5673:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(155);
module.exports = __webpack_require__(5674);


/***/ }),

/***/ 5674:
/***/ (function(module, exports, __webpack_require__) {

/* generated file - do not modify */
var onWindowIntl = function onWindowIntl() {
  __webpack_require__(157)(__webpack_require__(5675), [__webpack_require__(159), __webpack_require__(5832)], 'en', {
    "authorized": true,
    "deferLegalRedirect": true
  });

  var _require = __webpack_require__(117),
      addLocaleData = _require.addLocaleData;

  [__webpack_require__(160)].forEach(function (locale) {
    return addLocaleData(locale);
  });
};

var ensureFetch = function ensureFetch(cb) {
  if (typeof fetch === 'undefined') {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
      __webpack_require__(164);

      cb();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } else {
    cb();
  }
};

var ensureIntl = function ensureIntl(cb) {
  if (typeof window.Intl === 'undefined') {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
      __webpack_require__(57);

      __webpack_require__(58);

      cb();
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  } else {
    cb();
  }
}; // Check window.Intl, then check window.fetch, then load


ensureIntl(function () {
  ensureFetch(onWindowIntl);
});

/***/ }),

/***/ 5675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_browser_App__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homeIon_scss__ = __webpack_require__(5676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homeIon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__homeIon_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WelcomeView__ = __webpack_require__(5677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BusinessView__ = __webpack_require__(5706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WelcomeDownloadView__ = __webpack_require__(5738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PerformanceView__ = __webpack_require__(5740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FAQView__ = __webpack_require__(5746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CallLog__ = __webpack_require__(5749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__ = __webpack_require__(5752);
var _Route;














function createRoutes() {
  return _Route || (_Route = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_4__app_browser_App__["a" /* default */],
    path: "/"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_lib_IndexRoute___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__["a" /* default */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__["a" /* default */],
    path: "/home"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_12__BusinessListFeatureFlaggedPage__["a" /* default */],
    path: "/app/home"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_7__BusinessView__["a" /* default */],
    path: "/app/home/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_9__PerformanceView__["a" /* default */],
    path: "/app/performance/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_10__FAQView__["a" /* default */],
    path: "/app/performanceFAQ/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_6__WelcomeView__["a" /* default */],
    path: "/app/welcome/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_8__WelcomeDownloadView__["a" /* default */],
    path: "/app/welcome/:serviceProviderId/download-app"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_11__CallLog__["a" /* default */],
    path: "/app/callLog/:serviceProviderId"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_lib_Route___default.a, {
    component: __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser__["OfficeNotFoundView"],
    path: "*"
  })));
}

/***/ }),

/***/ 5676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WelcomeViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform_lib_browser_wizard__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform_lib_browser_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform_lib_browser_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_helmet_async__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_query_string__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__welcome_scss__ = __webpack_require__(5684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__welcome_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__welcome_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_BusinessDescriptionForm__ = __webpack_require__(5685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_ServiceCategoriesForm__ = __webpack_require__(5690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_browser_service_areas_ServiceAreaMap__ = __webpack_require__(2537);







var _Helmet, _span;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}
















var headers = [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
  key: "pageHeader"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("h1", {
  className: "h4"
}, "Your Business Description")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
  key: "pageHeader"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("h1", {
  className: "h4"
}, "Your Service Categories")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
  key: "pageHeader"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("h1", {
  className: "h4"
}, "Your Service Area"))];
/* eslint react/prefer-stateless-function: 0 */

var WelcomeViewComponent = /*#__PURE__*/function (_React$Component) {
  function WelcomeViewComponent() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, WelcomeViewComponent);

    return _callSuper(this, WelcomeViewComponent, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(WelcomeViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(WelcomeViewComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          serviceProviderCache = _this$props.serviceProviderCache,
          serviceProviderId = _this$props.params.serviceProviderId,
          location = _this$props.location;

      var serviceProviderLocation = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(serviceProviderCache, "".concat(serviceProviderId, ".primaryAddress.location"), {
        // default to Indianapolis
        lon: -86.1581,
        lat: 39.7684
      });

      var step = __WEBPACK_IMPORTED_MODULE_5_lodash_get___default()(__WEBPACK_IMPORTED_MODULE_15_query_string___default.a.parse(location.search), 'step', '1');

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_helmet_async___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("title", null, "Welcome"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Row___default.a, {
        className: __WEBPACK_IMPORTED_MODULE_16_classnames___default()({
          'service-area-step': step === '3'
        })
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform_lib_browser_wizard__["WizardComponent"], {
        router: this.context.router,
        id: "welcome--wizard",
        bsStyle: "primary-office",
        headers: headers,
        submitButtonContent: _span || (_span = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("span", {
          className: "wizard-button"
        }, "Done")),
        onFinalSubmit: function onFinalSubmit() {
          _this2.context.router.push({
            pathname: "/app/welcome/".concat(serviceProviderId, "/download-app")
          });
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__components_BusinessDescriptionForm__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        key: "BusinessDescription"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_ServiceCategoriesForm__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        key: "ServiceCategories"
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__app_browser_service_areas_ServiceAreaMap__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        advertisingArea: [],
        serviceArea: [],
        serviceProviderLocation: serviceProviderLocation,
        showEditControls: false,
        key: "ServiceAreas"
      }))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);
WelcomeViewComponent.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_9_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["connect"])(function (state) {
  return {
    serviceProviderCache: state.serviceProviderCache
  };
}), __WEBPACK_IMPORTED_MODULE_10_recompose_pure___default.a)(WelcomeViewComponent));

/***/ }),

/***/ 5684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessDescriptionFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_redux_form__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__businessDescriptionValidationRules__ = __webpack_require__(5686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__businessDescriptionAnalytics__ = __webpack_require__(5687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_welcomeActions__ = __webpack_require__(5688);








var _Row, _Row2;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}















var styles = {
  descriptionTextArea: {
    minHeight: 225
  }
};
/* eslint react/prefer-stateless-function: 0 */

var BusinessDescriptionFormComponent = /*#__PURE__*/function (_React$Component) {
  function BusinessDescriptionFormComponent(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, BusinessDescriptionFormComponent);

    _this2 = _callSuper(this, BusinessDescriptionFormComponent, [props]);

    // Need to explicitly define this as a function; method notation causes flow errors
    __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_defineProperty___default()(_this2, "updateBusinessDescriptionAndTrack", function (values) {
      var _this2$props = _this2.props,
          serviceProviderId = _this2$props.serviceProviderId,
          updateBusinessDescription = _this2$props.updateBusinessDescription;
      return updateBusinessDescription(serviceProviderId, values.businessDescription).then(function () {
        __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["tracker"].track('Item Clicked', {
          serviceProviderId: serviceProviderId,
          description: 'Welcome Business Description',
          activityLocation: 'SP : Welcome Business Description',
          userId: __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(_this2, 'props.user.userInfo.response.userId')
        });
      })["catch"](function () {
        var errorMessage = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span", null, "There was a problem updating your business description.  Please contact us at ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("a", {
          id: "welcome-view--add-business-description--error-link",
          href: __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["urlCatalog"].global.businessCenterPhone()
        }, __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["urlCatalog"].global.businessCenterPhoneText()), " for assistance.");
        throw new __WEBPACK_IMPORTED_MODULE_14_redux_form__["SubmissionError"]({
          _error: errorMessage
        });
      });
    });

    _this2.updateBusinessDescriptionAndTrack = _this2.updateBusinessDescriptionAndTrack.bind(_this2);
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(BusinessDescriptionFormComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(BusinessDescriptionFormComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          error = _this$props.error,
          welcomeStore = _this$props.welcomeStore;

      var isLoading = __WEBPACK_IMPORTED_MODULE_6_lodash_get___default()(welcomeStore, 'updateBusinessDescription.isLoading');

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_redux_form__["Form"], {
        onSubmit: handleSubmit(this.updateBusinessDescriptionAndTrack)
      }, error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, error) : null, _Row || (_Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("h5", null, "Your business description is one of the first things a member sees about your business. Include a clear, detailed overview of your business:"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "Start with your specialties and overview of services."), " This helps the member decide quickly if you can do their job."), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "State your value proposition."), " What makes you stand out from your competitors?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "Sell your background and staff."), " How long have you been in business or in this line of work? Are you owner-operated or a large business?"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("strong", null, "Avoid using terms that are specific to your industry."), " Potential customers may not be familiar with these."))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: isLoading,
        element: _Row2 || (_Row2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_redux_form__["Field"], {
        name: "businessDescription",
        id: "welcome-wizard--business-description",
        component: __WEBPACK_IMPORTED_MODULE_15_angieslist_app_platform_lib_browser_forms__["InputField"],
        type: "textarea",
        style: styles.descriptionTextArea,
        autoFocus: true
      }))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_14_redux_form__["reduxForm"])({
  form: 'welcomeBusinessDescriptionForm',
  validate: function validate(values) {
    return __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["validation"].validate(values, __WEBPACK_IMPORTED_MODULE_18__businessDescriptionValidationRules__["a" /* default */]).invalidAttrs;
  },
  destroyOnUnmount: false
}), Object(__WEBPACK_IMPORTED_MODULE_17_react_redux__["connect"])(function (state) {
  return {
    welcomeStore: state.welcome,
    user: state.user
  };
}, __WEBPACK_IMPORTED_MODULE_20__common_welcomeActions__), Object(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["analytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_19__businessDescriptionAnalytics__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_9_recompose_pure___default.a)(BusinessDescriptionFormComponent));

/***/ }),

/***/ 5686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  businessDescription: {
    required: true,
    minLength: 10,
    maxLength: 2000,
    textArea: true
  }
});

/***/ }),

/***/ 5687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);

/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: 'SP : Welcome Business Description',
    properties: __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
});

/***/ }),

/***/ 5688:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBusinessDescription", function() { return updateBusinessDescription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcomeActionKeys__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__welcomeService__ = __webpack_require__(5689);



var updateBusinessDescription = function updateBusinessDescription(serviceProviderId, businessDescription) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__welcomeActionKeys__["a" /* default */].UPDATE_BUSINESS_DESCRIPTION,
    payload: __WEBPACK_IMPORTED_MODULE_1__welcomeService__["a" /* updateBusinessDescription */](serviceProviderId, businessDescription)
  };
};
/* eslint-disable import/prefer-default-export */




/***/ }),

/***/ 5689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateBusinessDescription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_common_profileService__ = __webpack_require__(437);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var updateBusinessDescription = function updateBusinessDescription(serviceProviderId, description) {
  return __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["httpClient"].post("/gateway/office-home/v1/service_provider/".concat(serviceProviderId, "/profile/edit"), {
    headers: {
      'X-ANGI-CallerId': serviceProviderId
    },
    body: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__profile_common_profileService__["b" /* defaultUpdateRequest */]), {}, {
      description: {
        action: 'Update',
        data: description
      }
    })
  });
};
/* eslint-disable import/prefer-default-export */




/***/ }),

/***/ 5690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ServiceCategoriesFormComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_find__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_redux_form__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__serviceCategoriesAnalytics__ = __webpack_require__(5691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_common_categories_categoriesActions__ = __webpack_require__(1058);













var _Row, _Row2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}















var styles = {
  buttonStyle: {
    margin: '.5em',
    borderRadius: '1.5em'
  }
};

/* eslint react/prefer-stateless-function: 0 */
var ServiceCategoriesFormComponent = /*#__PURE__*/function (_React$Component) {
  function ServiceCategoriesFormComponent(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ServiceCategoriesFormComponent);

    _this2 = _callSuper(this, ServiceCategoriesFormComponent, [props]);

    // Need to explicitly define this as a function; method notation causes flow errors
    __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_defineProperty___default()(_this2, "addServiceCategories", function () {
      var _this2$props = _this2.props,
          serviceProviderId = _this2$props.serviceProviderId,
          addCategoriesToServiceProvider = _this2$props.addCategoriesToServiceProvider;
      return addCategoriesToServiceProvider(serviceProviderId, _this2.state.categoriesToAdd).then(function () {
        __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["tracker"].track('Item Clicked', {
          serviceProviderId: serviceProviderId,
          description: 'Welcome Service Categories',
          activityLocation: 'SP : Welcome Service Categories',
          userId: __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(_this2, 'props.user.userInfo.response.userId')
        });
      })["catch"](function () {
        var errorMessage = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("span", null, "There was a problem adding service categories.  Please contact us at ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("a", {
          id: "welcome-view--add-service-categories--error-link",
          href: __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["urlCatalog"].global.businessCenterPhone()
        }, __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["urlCatalog"].global.businessCenterPhoneText()), " for assistance.");
        throw new __WEBPACK_IMPORTED_MODULE_22_redux_form__["SubmissionError"]({
          _error: errorMessage
        });
      });
    });

    _this2.addServiceCategories = _this2.addServiceCategories.bind(_this2);
    _this2.state = {
      categoriesToAdd: []
    };
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(ServiceCategoriesFormComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ServiceCategoriesFormComponent, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          getServiceProviderCategories = _this$props.getServiceProviderCategories,
          serviceProviderId = _this$props.serviceProviderId;
      getServiceProviderCategories(serviceProviderId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          handleSubmit = _this$props2.handleSubmit,
          error = _this$props2.error,
          welcomeStore = _this$props2.welcomeStore;

      var isLoading = __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(welcomeStore, 'categoriesToAdd.isLoading');

      var currentCategories = __WEBPACK_IMPORTED_MODULE_11_lodash_get___default()(welcomeStore, 'serviceProviderCategories.response.categories');

      var categoryAutocompleteProps = {
        id: 'welcome-service-categories--add-category-autocomplete',
        placeholder: 'Start typing and select a category',
        autoFocus: false,
        iconLocation: 'none',
        requireSelection: true,
        clearAfterSelection: true,
        autocompleteEventHandler: function autocompleteEventHandler(event) {
          var newCategory = {
            name: event.displayText,
            id: event.categoryId
          };

          if (__WEBPACK_IMPORTED_MODULE_10_lodash_find___default()(currentCategories, {
            id: event.categoryId
          })) {
            _this3.setState({
              error: 'This category has already been added to your profile.'
            });
          } else {
            _this3.setState({
              categoriesToAdd: __WEBPACK_IMPORTED_MODULE_9_lodash_uniqBy___default()([].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(_this3.state.categoriesToAdd), [newCategory]), 'id'),
              error: ''
            });
          }
        }
      };
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_redux_form__["Form"], {
        onSubmit: handleSubmit(this.addServiceCategories)
      }, error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, error) : null, this.state.error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, this.state.error) : null, _Row || (_Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("h5", null, "Show members the services you offer"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("p", null, "Let us know what other services you offer in addition to the service category listed below.")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: isLoading,
        element: _Row2 || (_Row2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_angieslist_app_platform_lib_browser_autocomplete_categoryAutocomplete_CategoryAutocomplete___default.a, {
        categoryAutocompleteDetails: categoryAutocompleteProps
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(currentCategories, function (category) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button___default.a, {
          className: "existing-category",
          style: styles.buttonStyle,
          key: category.id,
          id: "category-management--add-category--existing-category-".concat(category.id),
          bsStyle: "primary-office",
          bsSize: "xsmall",
          flat: true,
          disabled: true
        }, category.name);
      }), __WEBPACK_IMPORTED_MODULE_8_lodash_map___default()(this.state.categoriesToAdd, function (category) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Button___default.a, {
          className: "new-category",
          style: styles.buttonStyle,
          key: category.id,
          id: "category-management--add-category--new-category-".concat(category.id),
          bsStyle: "primary-office",
          bsSize: "xsmall",
          flat: true,
          onClick: function onClick() {
            _this3.setState({
              categoriesToAdd: __WEBPACK_IMPORTED_MODULE_7_lodash_filter___default()(_this3.state.categoriesToAdd, function (c) {
                return c.id !== category.id;
              }),
              error: ''
            });
          }
        }, category.name, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_12_react___default.a.createElement("i", {
          className: "icon icon-close",
          style: {
            marginLeft: '0.7em'
          }
        }));
      })))))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_13_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_22_redux_form__["reduxForm"])({
  form: 'welcomeServiceCategoriesForm',
  destroyOnUnmount: false
}), Object(__WEBPACK_IMPORTED_MODULE_23_react_redux__["connect"])(function (state) {
  return {
    welcomeStore: state.welcome,
    user: state.user
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_25__app_common_categories_categoriesActions__)), Object(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["analytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_24__serviceCategoriesAnalytics__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_14_recompose_pure___default.a)(ServiceCategoriesFormComponent));

/***/ }),

/***/ 5691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);

/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: 'SP : Welcome Service Categories',
    properties: __WEBPACK_IMPORTED_MODULE_0__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
});

/***/ }),

/***/ 5706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export BusinessViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet_async__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ServiceProviderDashboard__ = __webpack_require__(2540);
var _Helmet;











var loader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
  className: "text-center"
}, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
  className: "icon icon-load icon-spin icon-5x text-primary"
}));
var BusinessViewComponent = function BusinessViewComponent(_ref) {
  var serviceProviderCache = _ref.serviceProviderCache,
      params = _ref.params,
      experiment = _ref.experiment;
  var serviceProviderId = params.serviceProviderId;
  var serviceProvider = serviceProviderCache[serviceProviderId];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet_async___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, "Dashboard"))), !serviceProvider || typeof serviceProvider.isAdvertiser === 'undefined' ? loader : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ServiceProviderDashboard__["a" /* default */], {
    serviceProvider: serviceProvider
  }));
};
var businessViewAnalytics = {
  page: {
    name: 'SP : Home',
    properties: __WEBPACK_IMPORTED_MODULE_7__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__["analytics"])({
  ruleset: businessViewAnalytics
}), Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state) {
  return {
    serviceProviderCache: state.serviceProviderCache,
    experiment: state.experimentV2
  };
}, __WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__["default"]), __WEBPACK_IMPORTED_MODULE_2_recompose_pure___default.a)(BusinessViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export WelcomeDownloadViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_browser_download_DownloadPrompt__ = __webpack_require__(2530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__welcomeDownloadAnalytics__ = __webpack_require__(5739);








var WelcomeDownloadViewComponent = function WelcomeDownloadViewComponent(props) {
  var serviceProviderId = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(props, 'params.serviceProviderId');

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__app_browser_download_DownloadPrompt__["a" /* default */], {
    header: "Download Our Pro Ads Mobile App",
    subheader: "Our best Angi Pro Ads experience, designed with you in mind.",
    showEscapeLink: true,
    serviceProviderId: serviceProviderId,
    referrer: "OfficeOnboardFunnel"
  });
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_5_angieslist_app_platform__["legacyAnalytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_7__welcomeDownloadAnalytics__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default.a)(WelcomeDownloadViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var activityLocation = 'SP : Welcome App Download';
/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: activityLocation,
    properties: __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  },
  elements: {
    'app-download--link-android': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'Android Pro App',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    },
    'app-download--link-ios': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'iOS Pro App',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    },
    'app-download--escape-link': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'No Thanks',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    },
    'app-download--send-sms-button': {
      click: {
        name: 'Item Clicked',
        properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["c" /* defaultProps */]), {}, {
          description: 'Welcome Send Link',
          activityLocation: activityLocation,
          serviceProviderId: '<<attributes.data-track-spid.value>>'
        })
      }
    }
  }
});

/***/ }),

/***/ 5740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export PerformanceViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_sortBy__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet_async__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_CategoryGroupMetrics__ = __webpack_require__(5741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_PerformanceViewHeader__ = __webpack_require__(5743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_performanceActions__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PerformanceView_scss__ = __webpack_require__(5745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__PerformanceView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__PerformanceView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__src_app_browser_analyticsDefaultProperties__ = __webpack_require__(44);









var _Helmet, _Row, _i, _Col;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}


















var PerformanceViewComponent = /*#__PURE__*/function (_React$Component) {
  function PerformanceViewComponent() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, PerformanceViewComponent);

    return _callSuper(this, PerformanceViewComponent, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(PerformanceViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(PerformanceViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var params = this.props.params;

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(params, 'serviceProviderId');

      var endTime = new Date();
      var startTime = new Date(new Date().setDate(endTime.getDate() - 90));
      this.props.getContactMetricsCategoryGroupsByServiceProvider({
        serviceProviderId: serviceProviderId,
        startTime: startTime,
        endTime: endTime
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$performan = _this$props.performance.contactMetricsByCategory,
          contactMetricsByCategoryResponse = _this$props$performan.response,
          contactMetricsByCategoryLoading = _this$props$performan.isLoading,
          contactMetricsByCategoryError = _this$props$performan.error,
          params = _this$props.params;

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(params, 'serviceProviderId');

      var categoryData = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(contactMetricsByCategoryResponse, 'categoryGroupMetrics'); // Prioritize advertising categories at the top


      var categoryDataSorted = __WEBPACK_IMPORTED_MODULE_6_lodash_sortBy___default()(categoryData, function (c) {
        return c.categoryGroup.hasAdvertisingIn;
      }).reverse();

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        id: "performance-view--".concat(serviceProviderId),
        className: "performance-view-wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_helmet_async___default.a, {
        title: "Performance"
      })), _Row || (_Row = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 9
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h1", null, "Performance")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 3,
        className: "last-90-days-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "Last 90 days")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: contactMetricsByCategoryLoading,
        element: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center",
          style: {
            marginTop: '1em'
          }
        }, _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        className: "performance-page-header",
        xs: 12
      }, contactMetricsByCategoryError ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger"
      }, "There was a problem retrieving your performance metrics. Please contact us at\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", {
        id: "service-areas--add-service-area--store-error-link",
        href: __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__["urlCatalog"].global.businessCenterPhone(),
        style: {
          whiteSpace: 'nowrap'
        }
      }, __WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__["urlCatalog"].global.businessCenterPhoneText()), " for assistance.") : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_PerformanceViewHeader__["a" /* default */], {
        serviceProviderId: serviceProviderId,
        contactMetrics: contactMetricsByCategoryResponse,
        isAdvertiser: true
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", {
        style: {
          marginBottom: '0.8em'
        }
      }, "Breakdown by Category Groups"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, _Col || (_Col = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12,
        md: 4
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "calls-explanation"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong", null, "How we know about phone calls"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Customers are required to click to reveal your phone number, and this lets us know what categories they are likely contacting you about. This data helps us estimate what categories your calls were about.")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12,
        md: 8
      }, categoryDataSorted ? categoryDataSorted.map(function (singleCategoryMetric) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_CategoryGroupMetrics__["a" /* default */], {
          key: singleCategoryMetric.categoryGroup.name,
          singleCategoryMetric: singleCategoryMetric,
          serviceProviderId: serviceProviderId,
          isAdvertiser: true
        });
      }) : null)))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
var performanceAnalytics = {
  page: {
    name: 'SP : Performance',
    properties: __WEBPACK_IMPORTED_MODULE_24__src_app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_10_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_18_angieslist_app_platform__["analytics"])({
  ruleset: performanceAnalytics
}), Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["connect"])(function (state) {
  return {
    user: state.user,
    performance: state.performance
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_22__common_performanceActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default.a)(PerformanceViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export CategoryGroupMetricsComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sum__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_last__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CustomerContactsChart__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_common_advertise_advertiseActions__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CategoryGroupMetrics_scss__ = __webpack_require__(5742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CategoryGroupMetrics_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__CategoryGroupMetrics_scss__);










var _div, _Col;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}













var isLastItem = function isLastItem(currentItem, subCategoryCollection) {
  return currentItem === __WEBPACK_IMPORTED_MODULE_7_lodash_last___default()(subCategoryCollection);
};

var calculateContactsPercentage = function calculateContactsPercentage(contactCount, contactTotal) {
  return contactCount / contactTotal * 100;
};

var trackCategory = function trackCategory(segmentDataCollection) {
  __WEBPACK_IMPORTED_MODULE_14_angieslist_app_platform__["tracker"].track('Item Displayed', {
    activityLocation: 'SP : Performance',
    contactCountDisplayed: segmentDataCollection.contactCountDisplayed,
    categoryGroupId: segmentDataCollection.categoryGroupId,
    description: segmentDataCollection.hasAdvertisingIn ? 'Advertising Category Group Contacts' : 'NonAdvertising Category Group Contacts',
    serviceProviderId: segmentDataCollection.serviceProviderId,
    userId: segmentDataCollection.userId
  });
};

var CategoryGroupMetricsComponent = /*#__PURE__*/function (_React$Component) {
  function CategoryGroupMetricsComponent() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, CategoryGroupMetricsComponent);

    return _callSuper(this, CategoryGroupMetricsComponent, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(CategoryGroupMetricsComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(CategoryGroupMetricsComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          serviceProviderId = _this$props.serviceProviderId,
          _this$props$singleCat = _this$props.singleCategoryMetric,
          aggregatedContactCount = _this$props$singleCat.aggregatedContactCount,
          _this$props$singleCat2 = _this$props$singleCat.categoryGroup,
          categoryGroupId = _this$props$singleCat2.categoryGroupId,
          hasAdvertisingIn = _this$props$singleCat2.hasAdvertisingIn,
          user = _this$props.user;
      var segmentDataCollection = {
        serviceProviderId: serviceProviderId,
        categoryGroupId: categoryGroupId,
        contactCountDisplayed: aggregatedContactCount,
        hasAdvertisingIn: hasAdvertisingIn,
        userId: user.userInfo.response.userId
      };
      trackCategory(segmentDataCollection);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          singleCategoryMetric = _this$props2.singleCategoryMetric,
          serviceProviderId = _this$props2.serviceProviderId;
      var subCategoryCollection = singleCategoryMetric.categoryGroup.categories;

      var typeMetrics = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(singleCategoryMetric, 'contactTypeMetrics', []);

      var callsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Calls';
      });

      var estimatedCallsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Estimated Calls';
      });

      var quotesMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'RequestAQuote';
      });

      var messagesMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'MessageSent';
      });

      var dealsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'DealClaimed';
      });

      var callCount = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callsMetrics, 'contactCount', 0);

      var estimatedCallCount = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(estimatedCallsMetrics, 'contactCount', 0);

      var quoteRequestsCount = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(quotesMetrics, 'contactCount', 0);

      var messagesCount = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(messagesMetrics, 'contactCount', 0);

      var claimedDealsCount = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(dealsMetrics, 'contactCount', 0);

      var totalCount = __WEBPACK_IMPORTED_MODULE_5_lodash_sum___default()([callCount, estimatedCallCount, quoteRequestsCount, messagesCount, claimedDealsCount]); // Category Specific Advertise With Us Upsell


      var isAdvertiserInCategory = singleCategoryMetric.categoryGroup.hasAdvertisingIn;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        className: "category-group-metrics--wrapper"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        className: "category-group-component"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, {
        className: "category-group-component-header"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        sm: 2,
        className: "category-group-component-sub-header hidden-xs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        className: "category-group-component-total-contacts-number"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("h2", null, singleCategoryMetric.aggregatedContactCount)), _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        className: "category-group-component-total-contacts-subtitle"
      }, "Contacts"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        className: "category-group-component-sub-header visible-xs"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("h3", {
        style: {
          marginLeft: '.4em',
          marginTop: 0
        }
      }, singleCategoryMetric.aggregatedContactCount, " Contacts")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        sm: 10,
        className: "category-group-component-category-info"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        style: {
          fontWeight: 'bold'
        }
      }, singleCategoryMetric.categoryGroup.name, isAdvertiserInCategory ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("span", {
        style: {
          fontWeight: 'normal',
          fontStyle: 'italic'
        }
      }, "\xA0(Advertising)") : null), subCategoryCollection.map(function (subCategoryItem) {
        return isLastItem(subCategoryItem, subCategoryCollection) ? "".concat(subCategoryItem.name) : "".concat(subCategoryItem.name, ", ");
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Row___default.a, null, _Col || (_Col = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 0,
        sm: 2
      }, "\xA0")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Col___default.a, {
        xs: 12,
        sm: 10,
        className: "category-group-component-metrics"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__CustomerContactsChart__["a" /* default */], {
        totalToDisplay: singleCategoryMetric ? singleCategoryMetric.aggregatedContactCount : 0,
        callsPercentage: calculateContactsPercentage(callCount + estimatedCallCount, totalCount),
        trackedCallsPercentage: calculateContactsPercentage(callCount, callCount + estimatedCallCount),
        quoteRequestsPercentage: calculateContactsPercentage(quoteRequestsCount, totalCount),
        messagesPercentage: calculateContactsPercentage(messagesCount, totalCount),
        claimedDealsPercentage: calculateContactsPercentage(claimedDealsCount, totalCount),
        strokeWidth: 4,
        serviceProviderId: serviceProviderId,
        isAdvertiser: true
      })))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_10_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_12_react_redux__["connect"])(function (state) {
  return {
    advertise: state.advertise,
    user: state.user
  };
}, __WEBPACK_IMPORTED_MODULE_18__app_common_advertise_advertiseActions__), __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default.a)(CategoryGroupMetricsComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5742:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sum__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sum___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sum__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CustomerContactsChart__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PerformanceViewHeader_scss__ = __webpack_require__(5744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PerformanceViewHeader_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__PerformanceViewHeader_scss__);




var _h, _div, _strong, _br, _div2;










var calculateContactsPercentage = function calculateContactsPercentage(contactCount, contactTotal) {
  return contactTotal > 0 ? contactCount / contactTotal * 100 : 0;
};

var PerformanceViewHeaderComponent = function PerformanceViewHeaderComponent(PerformanceViewHeaderProps) {
  var serviceProviderId = PerformanceViewHeaderProps.serviceProviderId,
      contactMetrics = PerformanceViewHeaderProps.contactMetrics,
      isAdvertiser = PerformanceViewHeaderProps.isAdvertiser;

  var typeMetrics = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(contactMetrics, 'contactTypeMetrics', {});

  var callsMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'Calls';
  });

  var estimatedCallsMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'Estimated Calls';
  });

  var quotesMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'RequestAQuote';
  });

  var messagesMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'MessageSent';
  });

  var dealsMetrics = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(typeMetrics, function (o) {
    return o.contactType === 'DealClaimed';
  });

  var callCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(callsMetrics, 'contactCount', 0);

  var estimatedCallCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(estimatedCallsMetrics, 'contactCount', 0);

  var quoteRequestsCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(quotesMetrics, 'contactCount', 0);

  var messagesCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(messagesMetrics, 'contactCount', 0);

  var claimedDealsCount = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(dealsMetrics, 'contactCount', 0);

  var totalCount = __WEBPACK_IMPORTED_MODULE_0_lodash_sum___default()([callCount, estimatedCallCount, quoteRequestsCount, messagesCount, claimedDealsCount]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    id: "performance-view-header-".concat(serviceProviderId),
    className: "performance-view-header-wrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 3,
    className: "performance-view-header-section contacts"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "contact-box"
  }, _h || (_h = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h4", null, "Customer Contacts")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h1", null, contactMetrics ? contactMetrics.aggregatedContactCount : 0), _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "last-90-days"
  }, "Last 90 days")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 6,
    className: "performance-view-header-section chart"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CustomerContactsChart__["a" /* default */], {
    totalToDisplay: contactMetrics ? contactMetrics.aggregatedContactCount : 0,
    callsPercentage: calculateContactsPercentage(callCount + estimatedCallCount, totalCount),
    trackedCallsPercentage: calculateContactsPercentage(callCount, callCount + estimatedCallCount),
    quoteRequestsPercentage: calculateContactsPercentage(quoteRequestsCount, totalCount),
    messagesPercentage: calculateContactsPercentage(messagesCount, totalCount),
    claimedDealsPercentage: calculateContactsPercentage(claimedDealsCount, totalCount),
    strokeWidth: 7,
    serviceProviderId: serviceProviderId,
    isAdvertiser: isAdvertiser
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 3,
    className: "performance-view-header-section misc"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "pro-tip"
  }, _strong || (_strong = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong", null, "Pro Tip: ")), " Refine your service area to get requests in the areas you want. ", _br || (_br = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("br", null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a", {
    id: "add-service-areas-link",
    href: __WEBPACK_IMPORTED_MODULE_8_angieslist_app_platform__["urlCatalog"].office.spProfile.serviceAreas(serviceProviderId)
  }, "Add Service Areas")), _div2 || (_div2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "calls-explanation"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong", null, "How we know about phone calls"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("p", null, "Customers are required to click to reveal your phone number, and this lets us know what categories they are likely contacting you about. This data helps us estimate what categories your calls were about."))))));
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_5_recompose_pure___default.a)(PerformanceViewHeaderComponent));

/***/ }),

/***/ 5744:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5745:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5746:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export FAQViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_helmet_async__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FAQAnalytics__ = __webpack_require__(5747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__faqView_scss__ = __webpack_require__(5748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__faqView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__faqView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_performanceActions__ = __webpack_require__(1063);









var _Helmet, _h, _h2, _p, _h3, _p2, _p3, _h4, _em, _p4, _h5, _h6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}














var FAQViewComponent = /*#__PURE__*/function (_React$Component) {
  function FAQViewComponent() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, FAQViewComponent);

    return _callSuper(this, FAQViewComponent, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(FAQViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(FAQViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var endTime = new Date();
      var startTime = new Date(new Date().setDate(endTime.getDate() - 90));
      var serviceProviderId = this.props.params.serviceProviderId;
      var getContactMetricsByServiceProvider = this.props.getContactMetricsByServiceProvider;
      getContactMetricsByServiceProvider({
        serviceProviderId: serviceProviderId,
        startTime: startTime,
        endTime: endTime
      });
      window.scrollTo(0, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          serviceProviderCache = _this$props.serviceProviderCache,
          contactMetrics = _this$props.performance.contactMetrics.response;

      var typeMetrics = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(contactMetrics, 'contactTypeMetrics', {});

      var callsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Calls';
      });

      var estimatedCallsMetrics = __WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(typeMetrics, function (o) {
        return o.contactType === 'Estimated Calls';
      });

      var callCount = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(callsMetrics, 'contactCount', 0);

      var estimatedCallCount = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(estimatedCallsMetrics, 'contactCount', 0);

      var totalCallCount = callCount + estimatedCallCount;
      var trackedCallPercentage = Math.round(totalCallCount > 0 ? callCount / totalCallCount * 100 : 0);
      var params = this.props.params;

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(params, 'serviceProviderId');

      var currentSP = serviceProviderCache[serviceProviderId];

      var isAdvertiser = __WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(currentSP, 'isAdvertiser', false);

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        style: {
          marginTop: '-1.25em'
        },
        className: "faq-container"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_helmet_async___default.a, {
        title: "Performance FAQ"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, _h || (_h = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h1", null, "Performance Metrics")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h3", {
        style: {
          marginBottom: '1.5em'
        }
      }, "Frequently Asked Questions"), _h2 || (_h2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "What are Customer Contacts?")), _p || (_p = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "The ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "overall"), " Customer Contacts metric represents the total count of contacts the registered business received over the designated time period minus any duplicate contacts sent by the same customer on the same day. If the same customer contacts the business twice in one day, Customer Contacts will only increase by one for that interaction. For example, if the same customer submits a Request a Quote and then calls through Angi on the same day for your business, Angi will only count the pair of contacts as a single Customer Contact. Messages in Message center are a means to communicate with customers who Request a Quote or Claim a Deal and each individual message does not count as a unique contact.")), isAdvertiser ? [_h3 || (_h3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", {
        key: "0"
      }, "What are category Customer Contacts?")), _p2 || (_p2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", {
        key: "1"
      }, "On the \"Performance\" page, you'll see a more detailed breakdown of your Customer Contacts. The number of Customer Contacts in a category group represents the total unique customers by day that contact your business over the time period ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "in a specific category group"), ". The same deduplication rules apply, but only for contacts in the same category group. If one customer contacts you for two or more category groups in one day, that customer will be counted uniquely in each ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "specific category group"), ", but only as one ", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", null, "overall"), "\xA0Customer Contact."))] : null, _p3 || (_p3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Around the Customer Contacts numbers, you'll see a donut graph. This represents the contact method distribution. You can use this to see how your customers have chosen to contact your business through the methods described below.")), isAdvertiser ? [_h4 || (_h4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", {
        key: "0"
      }, "What are Estimated Calls?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", {
        key: "1"
      }, "We can attribute most member phone calls to Angi Certified Pros due to our tracked phone numbers. However, some members contact Certified Pros outside our platform in a way we cannot directly track. Over a third of Angi members we sampled use the site to confirm recommendations from friends, neighbors, or family members, so they might already have your phone number. After a thorough analysis of our nationwide site traffic and reviews left without trackable contacts over the past year, we estimate on average how frequently this occurs.", totalCallCount > 0 ? [" Of the calls metric shown, ", trackedCallPercentage, "% are due to tracked phone calls. The remainder are from phone calls we believe happened off of our platform."] : null), _em || (_em = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("em", {
        key: "2"
      }, "How are calls assigned a category?")), _p4 || (_p4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", {
        key: "3"
      }, "Angi members are required to click to reveal your phone number, and this lets us know what categories they are likely to be contacting your business about. We use this data to estimate what categories your calls were about."))] : null, _h5 || (_h5 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "What are Quote Requests?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "Throughout our site, Angi members can click on 'Request a Quote' buttons that lead them down a multistep funnel that asks them several questions about their project and requires them to send their phone number and email address. These are shown on the\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", {
        id: "performance-faq--what-are-requests-lead",
        href: __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__["urlCatalog"].office.leadBoard(serviceProviderId)
      }, "Lead Board"), "\xA0and are labeled \"Quote Request.\""), _h6 || (_h6 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h4", null, "What are Claimed Deals?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p", null, "We show Angi members available deals to claim in a variety of places on our site including the 'Shop Deals' section and the featured spots on the top of search results. Your Client Success Manager can help you set up a Deal if you don\u2019t currently have one. These are shown on the\xA0", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a", {
        id: "performance-faq--what-are-deals-lead",
        href: __WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__["urlCatalog"].office.leadBoard(serviceProviderId)
      }, "Lead Board"), "\xA0and are labeled \"Claimed Deal.\"")))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_10_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_16_angieslist_app_platform__["analytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_18__FAQAnalytics__["a" /* default */]
}), Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function (state) {
  return {
    performance: state.performance,
    serviceProviderCache: state.serviceProviderCache
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_20__common_performanceActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_11_recompose_pure___default.a)(FAQViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsHelpers__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* harmony default export */ __webpack_exports__["a"] = ({
  identify: {},
  page: {
    name: 'SP : PerformanceFAQ',
    properties: _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_2__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]), {}, {
      userType: 'Authenticated'
    })
  },
  elements: {
    'performance-faq--*': Object(__WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsHelpers__["b" /* itemClicked */])('SP : PerformanceFAQ', 'Link')
  }
});

/***/ }),

/***/ 5748:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5749:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export CallLogComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNull__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_map__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_helmet_async__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_helmet_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_helmet_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__common_performanceActions__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CallLog_scss__ = __webpack_require__(5751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CallLog_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__CallLog_scss__);










var _Helmet, _i, _thead, _p;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}



















var CallLogComponent = /*#__PURE__*/function (_React$Component) {
  function CallLogComponent(props) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, CallLogComponent);

    _this2 = _callSuper(this, CallLogComponent, [props]);
    _this2.state = {
      pageIndex: 0
    };
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(CallLogComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(CallLogComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var offset = 0;
      var numberOfEntries = 25;
      var serviceProviderId = this.props.params.serviceProviderId;
      var getCallLogByServiceProvider = this.props.getCallLogByServiceProvider;
      getCallLogByServiceProvider({
        serviceProviderId: serviceProviderId,
        offset: offset,
        numberOfEntries: numberOfEntries
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          _this$props$performan = _this$props.performance.callLog,
          callLog = _this$props$performan.response,
          isLoading = _this$props$performan.isLoading,
          getCallLogByServiceProvider = _this$props.getCallLogByServiceProvider;

      var parsedDate = function parsedDate(call) {
        var localDate = __WEBPACK_IMPORTED_MODULE_21_moment___default()(call.date);
        return {
          localDate: localDate.format('L'),
          time: call.displayTime ? localDate.format('h:mm A') : 'N/A'
        };
      };

      var pageIndex = this.state.pageIndex;
      var numberOfEntries = 25;
      var pageCount = __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__["getPageCount"](__WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callLog, 'totalCalls', false), numberOfEntries);

      var callLogResponse = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callLog, 'phoneCalls', false);

      var parsedLocalDate = __WEBPACK_IMPORTED_MODULE_7_lodash_map___default()(callLogResponse, function (call) {
        return _objectSpread(_objectSpread({}, call), {}, {
          date: parsedDate(call)
        });
      });

      var totalCalls = __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(callLog, 'totalCalls', false);

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("div", {
        id: "Call-Log-Container",
        style: {
          background: 'white',
          paddingTop: 0,
          marginTop: '-1.25em'
        }
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_angieslist_react_components_lib_Grid___default.a, null, _Helmet || (_Helmet = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_helmet_async___default.a, {
        title: "Customer Call Log"
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, {
        xs: 12
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("h1", {
        style: {
          marginBottom: '.8em'
        }
      }, "Customer Call Log"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_angieslist_app_platform_lib_browser_Loader___default.a, {
        loading: isLoading,
        element: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, {
          className: "category-row text-center",
          style: {
            marginTop: '1em'
          }
        }, _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("i", {
          className: "icon icon-load icon-spin icon-3x text-primary"
        })))
      }, callLogResponse && !isLoading ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_angieslist_react_components_lib_Table___default.a, {
        responsive: true,
        striped: true
      }, _thead || (_thead = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("thead", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("tr", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Phone Number"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Date"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Time"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("th", null, "Call Duration (m:s)")))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("tbody", null, __WEBPACK_IMPORTED_MODULE_7_lodash_map___default()(parsedLocalDate, function (entry) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("tr", {
          key: entry.date
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, entry.number), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, entry.date.localDate), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, entry.date.time), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("td", null, !entry.duration || __WEBPACK_IMPORTED_MODULE_6_lodash_isNull___default()(entry.duration) ? 'N/A' : __WEBPACK_IMPORTED_MODULE_21_moment___default()(entry.duration * 1000).format('m:ss')));
      }))) : null, totalCalls === 0 ? _p || (_p = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("p", null, "No calls available")) : null))), pageCount > 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_angieslist_react_components_lib_Col___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_angieslist_react_components_lib_EllipsedPagination___default.a, {
        pageCount: pageCount,
        pageIndex: pageIndex,
        onChange: function onChange(i) {
          var serviceProviderId = _this3.props.params.serviceProviderId;
          var offset = __WEBPACK_IMPORTED_MODULE_22_angieslist_app_platform_lib_common_utils_paginationUtils__["getOffset"](i + 1, 25);
          getCallLogByServiceProvider({
            serviceProviderId: serviceProviderId,
            offset: offset,
            numberOfEntries: numberOfEntries
          });

          _this3.setState(function () {
            return {
              pageIndex: i
            };
          });

          __WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["tracker"].track('Item Clicked', {
            serviceProviderId: serviceProviderId,
            description: "Page ".concat(i + 1),
            activityLocation: 'SP : Call Log',
            userId: __WEBPACK_IMPORTED_MODULE_8_lodash_get___default()(_this3, 'props.user.userInfo.response.userId')
          });
        }
      }))) : null));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);
var CallLogAnalytics = {
  page: {
    name: 'SP : Customer Call Log',
    properties: __WEBPACK_IMPORTED_MODULE_25__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_11_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_19_angieslist_app_platform__["analytics"])({
  ruleset: CallLogAnalytics
}), Object(__WEBPACK_IMPORTED_MODULE_10_react_redux__["connect"])(function (state) {
  return {
    performance: state.performance
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_24__common_performanceActions__["a" /* default */])), __WEBPACK_IMPORTED_MODULE_12_recompose_pure___default.a)(CallLogComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5751:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BusinessListPage__ = __webpack_require__(5753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UnifiedBusinessListView__ = __webpack_require__(5822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__withBusinessListFeatureFlaggedPageConfig__ = __webpack_require__(5831);


var _i;

var _excluded = ["experiment"];

/* eslint-disable no-undef */







/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_recompose_compose___default()(__WEBPACK_IMPORTED_MODULE_7__withBusinessListFeatureFlaggedPageConfig__["a" /* default */])(function (_ref) {
  var _experiment$experimen;

  var experiment = _ref.experiment,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_angieslist_app_platform_lib_browser_Loader___default.a, {
    element: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_angieslist_react_components_lib_Row___default.a, {
      className: "category-row text-center",
      style: {
        marginTop: '1em'
      }
    }, _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i", {
      className: "icon icon-load icon-spin icon-3x text-primary"
    }))),
    loading: Object.keys(experiment.experiments).length === 0
  }, (_experiment$experimen = experiment.experiments) !== null && _experiment$experimen !== void 0 && (_experiment$experimen = _experiment$experimen.unifiedBusinessList) !== null && _experiment$experimen !== void 0 && _experiment$experimen.enabled ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__BusinessListPage__["a" /* default */], props) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__UnifiedBusinessListView__["a" /* default */], props));
}));

/***/ }),

/***/ 5753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessListPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_notFound_notFound__ = __webpack_require__(5754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_notFound_notFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_notFound_notFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__angi_snowplow_react__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__angi_snowplow_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__angi_snowplow_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__splitsoftware_splitio_react__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__angi_url_catalog__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__angi_url_catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__angi_url_catalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_browser_home_common_Icons__ = __webpack_require__(5811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BusinessListPage_scss__ = __webpack_require__(5812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__BusinessListPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__BusinessListPage_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_browser_home_BusinessList_components_Options__ = __webpack_require__(2557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_browser_home_BusinessList_components_FlatList__ = __webpack_require__(5814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_browser_home_BusinessList_components_HelpFooter__ = __webpack_require__(5816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_browser_analyticsHelpers__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_browser_home_BusinessList_components_CategorizedList__ = __webpack_require__(5818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_browser_home_BusinessList_components_BottomDrawerModal__ = __webpack_require__(5820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__ = __webpack_require__(2558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_common_businessList_businessListActions__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__common_splitSdkConfigSetup__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_selectedProDestination__ = __webpack_require__(2337);




var _div, _b, _AppraisersIcon, _i, _HelpFooter;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable import/no-named-as-default */



























var sortTypes = {
  ratings: 'Customer ratings (high to low)',
  reviews: 'Total reviews (high to low)'
};
var BusinessListPage = function BusinessListPage(_ref) {
  var businessList = _ref.businessList,
      serviceProviderCache = _ref.serviceProviderCache,
      getServiceProviders = _ref.getServiceProviders,
      isAuthenticated = _ref.isAuthenticated,
      config = _ref.config;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      showProductTypeSplitFlag = _useState2[0],
      setShowProductTypeSplitFlag = _useState2[1];

  var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
      _useState4 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState3, 2),
      splitFlagChecked = _useState4[0],
      setSplitFlagChecked = _useState4[1];

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    var client = Object(__WEBPACK_IMPORTED_MODULE_14__splitsoftware_splitio_react__["SplitSdk"])(Object(__WEBPACK_IMPORTED_MODULE_28__common_splitSdkConfigSetup__["c" /* splitSdkConfig */])(config.splitClientSideApiKey)).client();
    client.on(client.Event.SDK_READY, function () {
      var treatment = client.getTreatment(__WEBPACK_IMPORTED_MODULE_28__common_splitSdkConfigSetup__["b" /* PRO_LEADS_PRODUCTINFO_FRONTEND_BUSINESS_SELECT */]);
      setShowProductTypeSplitFlag(treatment === 'on');
      setSplitFlagChecked(true);
    });
  }, [isAuthenticated]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (isAuthenticated && splitFlagChecked) {
      getServiceProviders({
        limit: __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */],
        offset: __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__["a" /* DEFAULT_OFFSET */]
      });
    }
  }, [splitFlagChecked]);
  var snowplowParams = {
    pageName: 'sp : business list'
  };
  Object(__WEBPACK_IMPORTED_MODULE_13__angi_snowplow_react__["useEnhancedPageView"])(snowplowParams);

  var _useState5 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(''),
      _useState6 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState5, 2),
      sortByValue = _useState6[0],
      setSortByValue = _useState6[1];

  var _useState7 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
      _useState8 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState7, 2),
      openFilter = _useState8[0],
      setOpenFilter = _useState8[1];

  var _useState9 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(false),
      _useState10 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState9, 2),
      isResolvingDestination = _useState10[0],
      setIsResolvingDestination = _useState10[1];

  var isResolvingDestinationRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    var onPageShow = function onPageShow() {
      isResolvingDestinationRef.current = false;
      setIsResolvingDestination(false);
    };

    window.addEventListener('pageshow', onPageShow);
    return function () {
      return window.removeEventListener('pageshow', onPageShow);
    };
  }, []);

  var toggleBottomFilter = function toggleBottomFilter(openFilterValue) {
    setOpenFilter(openFilterValue);
  };

  var addActivityCount = function addActivityCount(sp) {
    if (sp.proType.toLowerCase() === 'leads') {
      var _ref3 = serviceProviderCache["HA-".concat(sp.id)] || {},
          _ref2$unreadLeadCount2 = _ref3.unreadLeadCount,
          _unreadLeadCount = _ref2$unreadLeadCount2 === void 0 ? 0 : _ref2$unreadLeadCount2,
          _ref2$opportunityCoun2 = _ref3.opportunityCount,
          opportunityCount = _ref2$opportunityCoun2 === void 0 ? 0 : _ref2$opportunityCoun2;

      return _objectSpread(_objectSpread({}, sp), {}, {
        activityCount: _unreadLeadCount + opportunityCount
      });
    }

    var _ref4 = serviceProviderCache[sp.id] || {},
        _ref4$unreadLeadCount = _ref4.unreadLeadCount,
        unreadLeadCount = _ref4$unreadLeadCount === void 0 ? 0 : _ref4$unreadLeadCount,
        _ref4$unreadDealCount = _ref4.unreadDealCount,
        unreadDealCount = _ref4$unreadDealCount === void 0 ? 0 : _ref4$unreadDealCount,
        _ref4$unreadQuoteCoun = _ref4.unreadQuoteCount,
        unreadQuoteCount = _ref4$unreadQuoteCoun === void 0 ? 0 : _ref4$unreadQuoteCoun,
        _ref4$unreadReviewCou = _ref4.unreadReviewCount,
        unreadReviewCount = _ref4$unreadReviewCou === void 0 ? 0 : _ref4$unreadReviewCou,
        _ref4$unreadMessageCo = _ref4.unreadMessageCount,
        unreadMessageCount = _ref4$unreadMessageCo === void 0 ? 0 : _ref4$unreadMessageCo;

    var total = unreadLeadCount + unreadDealCount + unreadQuoteCount + unreadReviewCount + unreadMessageCount;
    return _objectSpread(_objectSpread({}, sp), {}, {
      activityCount: total
    });
  };

  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(businessList, 'getServiceProviders.response') || {},
      _ref5$sortedBy = _ref5.sortedBy,
      sortedBy = _ref5$sortedBy === void 0 ? '' : _ref5$sortedBy,
      _ref5$serviceProvider = _ref5.serviceProviders,
      serviceProviders = _ref5$serviceProvider === void 0 ? [] : _ref5$serviceProvider,
      _ref5$totalCount = _ref5.totalCount,
      totalCount = _ref5$totalCount === void 0 ? 0 : _ref5$totalCount,
      _ref5$currentOffset = _ref5.currentOffset,
      currentOffset = _ref5$currentOffset === void 0 ? 0 : _ref5$currentOffset;

  var isLoading = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(businessList, 'getServiceProviders.isLoading', false); // businessListReducer redirect users with one business to homepage for Ads/Leads business.


  var showLoadingSpinner = totalCount === 1 || isLoading || !isAuthenticated;

  var error = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(businessList, 'getServiceProviders.error');

  var hasNoBusinesses = totalCount === 0;
  var selectedSortBy = sortedBy.toLowerCase();

  var onCardClicked = function onCardClicked(id, proType) {
    if (isResolvingDestinationRef.current) return;
    isResolvingDestinationRef.current = true;
    setIsResolvingDestination(true);
    Object(__WEBPACK_IMPORTED_MODULE_29__common_selectedProDestination__["a" /* default */])(id, proType).then(function (destination) {
      window.location.assign(destination);
    })["catch"](function () {
      if ((proType || '').toLowerCase() === 'leads') {
        window.location.assign(__WEBPACK_IMPORTED_MODULE_15__angi_url_catalog___default.a.office.leads.homePage(id));
        return;
      }

      window.location.assign("/app/home/".concat(id));
    });
  };

  var spsWithNotificationCounts = serviceProviders.map(addActivityCount);
  var pageIndex = __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageNum(currentOffset, __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */]) - 1;
  var pageCount = __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageCount(totalCount, __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */]);
  var list = selectedSortBy === 'name' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__modules_browser_home_BusinessList_components_CategorizedList__["a" /* default */], {
    serviceProviders: spsWithNotificationCounts,
    sortField: "name",
    onCardClicked: onCardClicked,
    productInfoFeatureFlag: showProductTypeSplitFlag
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__modules_browser_home_BusinessList_components_FlatList__["a" /* default */], {
    serviceProviders: spsWithNotificationCounts,
    onCardClicked: onCardClicked,
    productInfoFeatureFlag: showProductTypeSplitFlag
  });
  var optionsProps = {
    setSortBy: setSortByValue,
    sortByValue: sortByValue
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "businesspage-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    lg: 3,
    md: 4,
    sm: 5,
    xsHidden: true
  }, !openFilter ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__modules_browser_home_BusinessList_components_Options__["a" /* default */], optionsProps) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__modules_browser_home_BusinessList_components_BottomDrawerModal__["a" /* default */], {
    open: openFilter,
    closeDrawer: toggleBottomFilter,
    optionProps: optionsProps
  })), showLoadingSpinner ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      minHeight: 550
    }
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", {
    className: "icon icon-load text-primary icon-pulse icon-5x text-center"
  })))) : error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_Alert___default.a, {
    bsStyle: "danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__["getErrorMessage"])(error)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    className: "businesslist-data-container",
    xs: 12,
    md: 8,
    sm: 12,
    lg: 9
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "businesslist-scroll-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "scroll-body"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "business-title-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "h2 businesslist-title"
  }, _b || (_b = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("b", null, "Choose a business to manage")), selectedSortBy !== 'name' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "h4 business-sort-type"
  }, sortTypes[selectedSortBy]))), hasNoBusinesses ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_office_app_common_lib_v1_notFound_notFound___default.a, {
    title: "You don\u2019t have any businesses yet.",
    subtitle: "When you do, you can find them here.",
    buttonText: "Refresh",
    onClick: function onClick() {
      return window.location.reload();
    },
    className: "empty-business-list-container",
    useLegacyWrapper: false,
    customIcon: _AppraisersIcon || (_AppraisersIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__modules_browser_home_common_Icons__["a" /* AppraisersIcon */], null))
  }) : [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: "filter-wrapper",
    key: "0"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    lgHidden: true,
    mdHidden: true,
    smHidden: true
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    id: "options-filter-btn",
    role: "button",
    tabIndex: 0,
    className: "options-filter-btn",
    onClick: function onClick() {
      return toggleBottomFilter(true);
    },
    onKeyDown: function onKeyDown() {
      return toggleBottomFilter(true);
    }
  }, "Sort ", _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("i", {
    className: "icon icon-down-open"
  }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    style: isResolvingDestination ? {
      pointerEvents: 'none'
    } : undefined,
    "aria-busy": isResolvingDestination || undefined,
    key: "1"
  }, list)]), pageCount > 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    md: 8
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_EllipsedPagination___default.a, {
    pageCount: pageCount,
    pageIndex: pageIndex,
    onChange: function onChange(index) {
      var newOffset = __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getOffset(index + 1, __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */]);
      getServiceProviders({
        offset: newOffset,
        limit: __WEBPACK_IMPORTED_MODULE_26__modules_browser_home_common_BusinessListConstants__["b" /* PROS_PER_PAGE */],
        sortBy: sortByValue
      });
    }
  }))) : null, _HelpFooter || (_HelpFooter = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__modules_browser_home_BusinessList_components_HelpFooter__["a" /* default */], null)))));
};
var businessListPageAnalytics = {
  page: {
    name: 'SP : Business List',
    properties: __WEBPACK_IMPORTED_MODULE_17__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */]
  },
  elements: {
    'sp-business-card': {
      click: {
        name: 'Item Clicked',
        properties: {
          'field-name': 'Bussiness Card Clicked'
        }
      },
      mouseover: {
        name: 'Item Clicked',
        properties: {
          activityLocation: 'SP : Business List',
          description: 'User hovers over the choose button on a business in the business list',
          spId: '<<attributes.spid.value>>'
        }
      }
    },
    email: Object(__WEBPACK_IMPORTED_MODULE_22__app_browser_analyticsHelpers__["b" /* itemClicked */])('SP : Business List', 'User clicks email support address'),
    phone: Object(__WEBPACK_IMPORTED_MODULE_22__app_browser_analyticsHelpers__["b" /* itemClicked */])('SP : Business List', 'User clicks phone support number')
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_angieslist_app_platform__["analytics"])({
  ruleset: businessListPageAnalytics
})(Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    businessList: state.businessList,
    serviceProviderCache: state.serviceProviderCache,
    experiment: state.experimentV2,
    isAuthenticated: !!state.auth.isAuthenticated
  };
}, _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_27__app_common_businessList_businessListActions__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_23__app_common_serviceProvider_serviceProviderActions__["default"]))( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(BusinessListPage))));

/***/ }),

/***/ 5754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _urlCatalog = _interopRequireDefault(__webpack_require__(85));

var _ = __webpack_require__(2550);

var _tailwindLegacyWrapper = _interopRequireDefault(__webpack_require__(2551));

var _emptyStates = __webpack_require__(5778);

var _Button = _interopRequireDefault(__webpack_require__(19));

__webpack_require__(5810);

var extractSpidFromPath = function extractSpidFromPath() {
  if (typeof window !== 'undefined' && window.location.pathname.includes('/app/h/')) {
    return window.location.pathname.split('/app/h/')[1].split('/')[0];
  }

  return '';
};

var PAGE_NOT_FOUND_TITLE = 'Page not found';
var PAGE_NOT_FOUND_SUBTITLE = 'The page you\'re looking for doesn\'t exist or has been moved.';
var GO_BACK_BUTTON_TEXT = 'Go back to home';

var handleButtonClick = function handleButtonClick(spid, onClick) {
  if (onClick) {
    onClick();
  } else if (spid) {
    window.location.href = _urlCatalog["default"].office.leads.homePage(Number(spid));
  } else {
    window.location.href = _urlCatalog["default"].officeRoot;
  }
};

var DefaultIcon = /*#__PURE__*/_react["default"].createElement(_.AlertIcon32, {
  className: "alert-icon-associate-generic-error-page"
});

var renderFromEmptyProjects = function renderFromEmptyProjects(spid, title, subtitle, buttonText, customIcon, onClick) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "empty-projects-container"
  }, /*#__PURE__*/_react["default"].createElement(_tailwindLegacyWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_emptyStates.EmptyProjects, {
    title: title || PAGE_NOT_FOUND_TITLE,
    subtitle: subtitle || PAGE_NOT_FOUND_SUBTITLE,
    buttonText: buttonText || GO_BACK_BUTTON_TEXT,
    Icon: customIcon || DefaultIcon,
    onButtonClicked: function onButtonClicked() {
      return handleButtonClick(spid, onClick);
    }
  })));
};

var renderFromNotFound = function renderFromNotFound(spid, title, subtitle, buttonText, customIcon, iconWrapperClassName, className, _onClick) {
  var Icon = customIcon || DefaultIcon;
  var finalTitle = title || PAGE_NOT_FOUND_TITLE;
  var finalSubtitle = subtitle || PAGE_NOT_FOUND_SUBTITLE;
  var finalButtonText = buttonText || GO_BACK_BUTTON_TEXT;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "not-found-container ".concat(className || '').trim()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "not-found-root"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "not-found-icon-wrapper ".concat(iconWrapperClassName || '').trim()
  }, Icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: "not-found-title"
  }, finalTitle), /*#__PURE__*/_react["default"].createElement("span", {
    className: "not-found-subtitle"
  }, finalSubtitle), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    "data-snowplow-leads-service-provider-id": spid,
    className: "not-found-submit-button",
    bsStyle: "primary-office",
    onClick: function onClick() {
      return handleButtonClick(spid, _onClick);
    }
  }, finalButtonText)));
};

var NotFound = function NotFound(_ref) {
  var useLegacyWrapper = _ref.useLegacyWrapper,
      title = _ref.title,
      subtitle = _ref.subtitle,
      buttonText = _ref.buttonText,
      customIcon = _ref.customIcon,
      iconWrapperClassName = _ref.iconWrapperClassName,
      className = _ref.className,
      onClick = _ref.onClick;
  var spid = extractSpidFromPath();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "theme-pro"
  }, useLegacyWrapper ? renderFromEmptyProjects(spid, title, subtitle, buttonText, customIcon, onClick) : renderFromNotFound(spid, title, subtitle, buttonText, customIcon, iconWrapperClassName, className, onClick));
};

NotFound.defaultProps = {
  title: '',
  subtitle: '',
  buttonText: '',
  customIcon: null,
  iconWrapperClassName: '',
  className: '',
  onClick: null
};
var _default = NotFound;
exports["default"] = _default;

/***/ }),

/***/ 5778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyProjects = void 0;
var EmptyProjects_1 = __webpack_require__(5779);
Object.defineProperty(exports, "EmptyProjects", { enumerable: true, get: function () { return EmptyProjects_1.EmptyProjects; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpREFBZ0Q7QUFFdkMsOEZBRkEsNkJBQWEsT0FFQSJ9

/***/ }),

/***/ 5779:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyProjects = void 0;
var react_1 = __importDefault(__webpack_require__(0));
var button_1 = __importDefault(__webpack_require__(5780));
var clsx_1 = __importDefault(__webpack_require__(499));
var EmptyProjects_module_css_1 = __importDefault(__webpack_require__(5809));
exports.EmptyProjects = react_1.default.forwardRef(function (_a, ref) {
    var title = _a.title, onButtonClicked = _a.onButtonClicked, buttonText = _a.buttonText, Icon = _a.Icon, iconWrapperClassName = _a.iconWrapperClassName, subtitle = _a.subtitle, className = _a.className, props = __rest(_a, ["title", "onButtonClicked", "buttonText", "Icon", "iconWrapperClassName", "subtitle", "className"]);
    return (react_1.default.createElement("div", __assign({}, props, { ref: ref, className: (0, clsx_1.default)(EmptyProjects_module_css_1.default.root, className) }),
        react_1.default.createElement("div", { className: (0, clsx_1.default)(EmptyProjects_module_css_1.default.icon, iconWrapperClassName) }, Icon),
        react_1.default.createElement("h2", { className: EmptyProjects_module_css_1.default.title }, title),
        subtitle && react_1.default.createElement("span", { className: EmptyProjects_module_css_1.default.subtitle }, subtitle),
        buttonText && onButtonClicked && (react_1.default.createElement(button_1.default, { className: EmptyProjects_module_css_1.default.submitButton, variant: "primary", onClick: onButtonClicked }, buttonText))));
});
exports.EmptyProjects.displayName = 'EmptyProjects';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW1wdHlQcm9qZWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL0VtcHR5UHJvamVjdHMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFDQSxnREFBMEI7QUFDMUIsd0RBQWtDO0FBQ2xDLDhDQUF3QjtBQUN4Qix3RkFBZ0Q7QUFZbkMsUUFBQSxhQUFhLEdBQUcsZUFBSyxDQUFDLFVBQVUsQ0FDM0MsVUFDRSxFQVNxQixFQUNyQixHQUFpQztJQVQvQixJQUFBLEtBQUssV0FBQSxFQUNMLGVBQWUscUJBQUEsRUFDZixVQUFVLGdCQUFBLEVBQ1YsSUFBSSxVQUFBLEVBQ0osb0JBQW9CLDBCQUFBLEVBQ3BCLFFBQVEsY0FBQSxFQUNSLFNBQVMsZUFBQSxFQUNOLEtBQUssY0FSVixtR0FTQyxDQURTO0lBSVYsT0FBTyxDQUNMLGtEQUFTLEtBQUssSUFBRSxHQUFHLEVBQUUsR0FBRyxFQUFFLFNBQVMsRUFBRSxJQUFBLGNBQUksRUFBQyxrQ0FBTSxDQUFDLElBQUksRUFBRSxTQUFTLENBQUM7UUFDL0QsdUNBQUssU0FBUyxFQUFFLElBQUEsY0FBSSxFQUFDLGtDQUFNLENBQUMsSUFBSSxFQUFFLG9CQUFvQixDQUFDLElBQUcsSUFBSSxDQUFPO1FBQ3JFLHNDQUFJLFNBQVMsRUFBRSxrQ0FBTSxDQUFDLEtBQUssSUFBRyxLQUFLLENBQU07UUFDeEMsUUFBUSxJQUFJLHdDQUFNLFNBQVMsRUFBRSxrQ0FBTSxDQUFDLFFBQVEsSUFBRyxRQUFRLENBQVE7UUFDL0QsVUFBVSxJQUFJLGVBQWUsSUFBSSxDQUNoQyw4QkFBQyxnQkFBTSxJQUNMLFNBQVMsRUFBRSxrQ0FBTSxDQUFDLFlBQVksRUFDOUIsT0FBTyxFQUFDLFNBQVMsRUFDakIsT0FBTyxFQUFFLGVBQWUsSUFFdkIsVUFBVSxDQUNKLENBQ1YsQ0FDRyxDQUNQLENBQUM7QUFDSixDQUFDLENBQ0YsQ0FBQztBQUVGLHFCQUFhLENBQUMsV0FBVyxHQUFHLGVBQWUsQ0FBQyJ9

/***/ }),

/***/ 5780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlessButton = exports.CtaGroup = exports.Button = void 0;
var Button_1 = __webpack_require__(2552);
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return Button_1.Button; } });
var CtaGroup_1 = __webpack_require__(5807);
Object.defineProperty(exports, "CtaGroup", { enumerable: true, get: function () { return CtaGroup_1.CtaGroup; } });
var HeadlessButton_1 = __webpack_require__(2553);
Object.defineProperty(exports, "HeadlessButton", { enumerable: true, get: function () { return HeadlessButton_1.HeadlessButton; } });
exports.default = Button_1.Button;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBa0M7QUFRekIsdUZBUkEsZUFBTSxPQVFBO0FBUGYsdUNBQXNDO0FBT3JCLHlGQVBSLG1CQUFRLE9BT1E7QUFOekIsbURBQWtEO0FBTXZCLCtGQU5sQiwrQkFBYyxPQU1rQjtBQUR6QyxrQkFBZSxlQUFNLENBQUMifQ==

/***/ }),

/***/ 5781:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5782:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUniqueId = exports.formatErrorString = exports.useTrackingContext = exports.TrackingContextProvider = exports.Track = exports.trackEvent = exports.formatChildren = exports.EventNames = exports.useMedia = exports.useIsMounted = exports.useOnGlobalKeyUp = exports.useOnGlobalKeyDown = exports.useOnClickOutside = exports.Wrap = exports.useIsWebView = exports.useOpenAccessibe = exports.useSetTimeout = exports.createFormikWrapper = void 0;
var useIsWebView_1 = __importDefault(__webpack_require__(5783));
exports.useIsWebView = useIsWebView_1.default;
var createFormikWrapper_1 = __webpack_require__(5784);
Object.defineProperty(exports, "createFormikWrapper", { enumerable: true, get: function () { return createFormikWrapper_1.createFormikWrapper; } });
var useSetTimeout_1 = __webpack_require__(2554);
Object.defineProperty(exports, "useSetTimeout", { enumerable: true, get: function () { return useSetTimeout_1.useSetTimeout; } });
var useOpenAccessibe_1 = __webpack_require__(5787);
Object.defineProperty(exports, "useOpenAccessibe", { enumerable: true, get: function () { return useOpenAccessibe_1.useOpenAccessibe; } });
var Wrap_1 = __webpack_require__(2555);
Object.defineProperty(exports, "Wrap", { enumerable: true, get: function () { return Wrap_1.Wrap; } });
var useOnOutsideEvent_1 = __webpack_require__(5788);
Object.defineProperty(exports, "useOnClickOutside", { enumerable: true, get: function () { return useOnOutsideEvent_1.useOnClickOutside; } });
Object.defineProperty(exports, "useOnGlobalKeyDown", { enumerable: true, get: function () { return useOnOutsideEvent_1.useOnGlobalKeyDown; } });
Object.defineProperty(exports, "useOnGlobalKeyUp", { enumerable: true, get: function () { return useOnOutsideEvent_1.useOnGlobalKeyUp; } });
var useIsMounted_1 = __webpack_require__(5789);
Object.defineProperty(exports, "useIsMounted", { enumerable: true, get: function () { return useIsMounted_1.useIsMounted; } });
var use_media_1 = __webpack_require__(5790);
Object.defineProperty(exports, "useMedia", { enumerable: true, get: function () { return use_media_1.useMedia; } });
var trackEvent_1 = __webpack_require__(1554);
Object.defineProperty(exports, "EventNames", { enumerable: true, get: function () { return trackEvent_1.EventNames; } });
Object.defineProperty(exports, "formatChildren", { enumerable: true, get: function () { return trackEvent_1.formatChildren; } });
Object.defineProperty(exports, "trackEvent", { enumerable: true, get: function () { return trackEvent_1.trackEvent; } });
var Track_1 = __webpack_require__(5791);
Object.defineProperty(exports, "Track", { enumerable: true, get: function () { return Track_1.Track; } });
var trackingContext_1 = __webpack_require__(2556);
Object.defineProperty(exports, "TrackingContextProvider", { enumerable: true, get: function () { return trackingContext_1.TrackingContextProvider; } });
Object.defineProperty(exports, "useTrackingContext", { enumerable: true, get: function () { return trackingContext_1.useTrackingContext; } });
var formatErrorString_1 = __webpack_require__(5792);
Object.defineProperty(exports, "formatErrorString", { enumerable: true, get: function () { return formatErrorString_1.formatErrorString; } });
var use_unique_id_1 = __webpack_require__(5793);
Object.defineProperty(exports, "useUniqueId", { enumerable: true, get: function () { return __importDefault(use_unique_id_1).default; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxnRUFBMEM7QUFRakMsdUJBUkYsc0JBQVksQ0FRRTtBQU5yQiw2REFBNEQ7QUFBbkQsMEhBQUEsbUJBQW1CLE9BQUE7QUFHNUIsaURBQWdEO0FBQXZDLDhHQUFBLGFBQWEsT0FBQTtBQUV0Qix1REFBc0Q7QUFBN0Msb0hBQUEsZ0JBQWdCLE9BQUE7QUFHekIsK0JBQThCO0FBQXJCLDRGQUFBLElBQUksT0FBQTtBQUViLHlEQUk2QjtBQUgzQixzSEFBQSxpQkFBaUIsT0FBQTtBQUNqQix1SEFBQSxrQkFBa0IsT0FBQTtBQUNsQixxSEFBQSxnQkFBZ0IsT0FBQTtBQUdsQiwrQ0FBOEM7QUFBckMsNEdBQUEsWUFBWSxPQUFBO0FBRXJCLHlDQUF1QztBQUE5QixxR0FBQSxRQUFRLE9BQUE7QUFJakIsMkNBQXNFO0FBQTdELHdHQUFBLFVBQVUsT0FBQTtBQUFFLDRHQUFBLGNBQWMsT0FBQTtBQUFFLHdHQUFBLFVBQVUsT0FBQTtBQUUvQyxpQ0FBZ0M7QUFBdkIsOEZBQUEsS0FBSyxPQUFBO0FBRWQscURBQWdGO0FBQXZFLDBIQUFBLHVCQUF1QixPQUFBO0FBQUUscUhBQUEsa0JBQWtCLE9BQUE7QUFFcEQseURBQXdEO0FBQS9DLHNIQUFBLGlCQUFpQixPQUFBO0FBRTFCLGlEQUF5RDtBQUFoRCw2SEFBQSxPQUFPLE9BQWUifQ==

/***/ }),

/***/ 5783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inferWebviewFromUserAgent = void 0;
var react_1 = __webpack_require__(0);
var inferWebviewFromUserAgent = function (userAgent) {
    var isAndroidApp = /android/i.test(userAgent) && userAgent.includes('wv');
    var isIphoneApp = /iPhone/.test(userAgent) &&
        !userAgent.includes('Safari') &&
        !userAgent.includes('Chrome');
    return {
        isAndroidApp: isAndroidApp,
        isIphoneApp: isIphoneApp,
    };
};
exports.inferWebviewFromUserAgent = inferWebviewFromUserAgent;
/**
 * @deprecated
 * Custom hook to detect if the current environment is a WebView in an iOS or Android app
 * or if it’s accessed through a standard web browser.
 *
 * This hook uses the `navigator.userAgent` string to identify the platform type.
 *
 * @returns {Object} An object containing:
 * - `isWebView` (boolean): Indicates if the app is running in a WebView (`true`) or not (`false`).
 * - `appOS` (string | null): Specifies the platform type, which can be one of:
 *   - 'iOS' for iOS WebView
 *   - 'Android' for Android WebView
 *   - null for standard web browsers
 *
 * @example
 * const { isWebView, appOS } = useIsWebView();
 * if (isWebView) {
 *   console.log(`Running inside a ${appOS} WebView`);
 * }
 */
var useIsWebView = function () {
    var _a = __read((0, react_1.useState)(false), 2), isWebView = _a[0], setIsWebView = _a[1];
    var _b = __read((0, react_1.useState)(null), 2), appOS = _b[0], setAppOS = _b[1];
    (0, react_1.useEffect)(function () {
        var _a = (0, exports.inferWebviewFromUserAgent)(navigator.userAgent), isIphoneApp = _a.isIphoneApp, isAndroidApp = _a.isAndroidApp;
        setIsWebView(isAndroidApp || isIphoneApp);
        if (isIphoneApp) {
            setAppOS('iOS');
        }
        else if (isAndroidApp) {
            setAppOS('Android');
        }
    }, []);
    return (0, react_1.useMemo)(function () { return ({ isWebView: isWebView, appOS: appOS }); }, [isWebView, appOS]);
};
exports.default = useIsWebView;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlSXNXZWJWaWV3LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vdXNlSXNXZWJWaWV3LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQkFBcUQ7QUFFOUMsSUFBTSx5QkFBeUIsR0FBRyxVQUFDLFNBQWlCO0lBQ3pELElBQU0sWUFBWSxHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksU0FBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUU1RSxJQUFNLFdBQVcsR0FDZixRQUFRLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQztRQUN4QixDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsUUFBUSxDQUFDO1FBQzdCLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztJQUVoQyxPQUFPO1FBQ0wsWUFBWSxjQUFBO1FBQ1osV0FBVyxhQUFBO0tBQ1osQ0FBQztBQUNKLENBQUMsQ0FBQztBQVpXLFFBQUEseUJBQXlCLDZCQVlwQztBQUVGOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBbUJHO0FBQ0gsSUFBTSxZQUFZLEdBQUc7SUFDYixJQUFBLEtBQUEsT0FBNEIsSUFBQSxnQkFBUSxFQUFDLEtBQUssQ0FBQyxJQUFBLEVBQTFDLFNBQVMsUUFBQSxFQUFFLFlBQVksUUFBbUIsQ0FBQztJQUM1QyxJQUFBLEtBQUEsT0FBb0IsSUFBQSxnQkFBUSxFQUFnQixJQUFJLENBQUMsSUFBQSxFQUFoRCxLQUFLLFFBQUEsRUFBRSxRQUFRLFFBQWlDLENBQUM7SUFFeEQsSUFBQSxpQkFBUyxFQUFDO1FBQ0YsSUFBQSxLQUFnQyxJQUFBLGlDQUF5QixFQUM3RCxTQUFTLENBQUMsU0FBUyxDQUNwQixFQUZPLFdBQVcsaUJBQUEsRUFBRSxZQUFZLGtCQUVoQyxDQUFDO1FBRUYsWUFBWSxDQUFDLFlBQVksSUFBSSxXQUFXLENBQUMsQ0FBQztRQUUxQyxJQUFJLFdBQVcsRUFBRSxDQUFDO1lBQ2hCLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNsQixDQUFDO2FBQU0sSUFBSSxZQUFZLEVBQUUsQ0FBQztZQUN4QixRQUFRLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDdEIsQ0FBQztJQUNILENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUVQLE9BQU8sSUFBQSxlQUFPLEVBQUMsY0FBTSxPQUFBLENBQUMsRUFBRSxTQUFTLFdBQUEsRUFBRSxLQUFLLE9BQUEsRUFBRSxDQUFDLEVBQXRCLENBQXNCLEVBQUUsQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDLENBQUMsQ0FBQztBQUNuRSxDQUFDLENBQUM7QUFDRixrQkFBZSxZQUFZLENBQUMifQ==

/***/ }),

/***/ 5784:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFormikWrapper = createFormikWrapper;
var react_1 = __importDefault(__webpack_require__(0));
var formik_1 = __webpack_require__(5785);
var useSetTimeout_1 = __importDefault(__webpack_require__(2554));
var Wrap_1 = __importDefault(__webpack_require__(2555));
/**
 * Wraps a given component for use within Formik
 * @param fieldToProps - Function which accepts formik field data and returns an object of props to be passed to the field
 */
function createFormikWrapper(Component, displayName, fieldToProps) {
    var component = react_1.default.forwardRef(function (props, ref) {
        var name = props.name, wrapper = props.wrapper, rest = __rest(props, ["name", "wrapper"]);
        var _a = __read((0, formik_1.useField)(name), 3), field = _a[0], meta = _a[1], helpers = _a[2];
        var setTimeout = (0, useSetTimeout_1.default)();
        var maybeModifiedField = __assign({}, field);
        /*
         * Blur events often result in validation errors, which can move elements on the page and block click events.
         * Delaying blur events to the next tick allows clicks to fire before the element is moved.
         */
        var onBlur = field.onBlur;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (onBlur) {
            maybeModifiedField.onBlur = function (e) {
                setTimeout(function () { return onBlur(e); }, 0);
            };
        }
        var formikProps = fieldToProps([maybeModifiedField, meta, helpers], props);
        if (formikProps && typeof formikProps === 'object') {
            Object.keys(formikProps).forEach(function (prop) {
                var _a = rest, _b = prop, passedFn = _a[_b];
                var _c = formikProps, _d = prop, formikFn = _c[_d];
                if (typeof passedFn === 'function' &&
                    typeof formikFn === 'function' &&
                    formikFn !== passedFn) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    rest[prop] = function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        formikFn.apply(void 0, __spreadArray([], __read(args), false));
                        passedFn.apply(void 0, __spreadArray([], __read(args), false));
                    };
                }
            });
        }
        return (react_1.default.createElement(Wrap_1.default, { wrapper: wrapper },
            react_1.default.createElement(Component, __assign({ name: name }, formikProps, rest, { ref: ref }))));
    });
    component.displayName = displayName;
    return component;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 5785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorMessage", function() { return ErrorMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FastField", function() { return FastField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return Field; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FieldArray", function() { return FieldArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Formik", function() { return Formik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikConsumer", function() { return FormikConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikContext", function() { return FormikContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormikProvider", function() { return FormikProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return connect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActiveElement", function() { return getActiveElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "insert", function() { return insert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyArray", function() { return isEmptyArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmptyChildren", function() { return isEmptyChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInputEvent", function() { return isInputEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInteger", function() { return isInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNaN", function() { return isNaN$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isString", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "move", function() { return move; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareDataForValidation", function() { return prepareDataForValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIn", function() { return setIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNestedObjectValues", function() { return setNestedObjectValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "swap", function() { return swap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useField", function() { return useField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useFormik", function() { return useFormik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useFormikContext", function() { return useFormikContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateYupSchema", function() { return validateYupSchema; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withFormik", function() { return withFormik; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yupToFormErrors", function() { return yupToFormErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deepmerge__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_cloneDeep__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fast_compare__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_clone__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_toPath__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__ = __webpack_require__(5786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__);










function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var FormikContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react__["createContext"])(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(FormikContext);
  !!!formik ?  false ? invariant(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
  return formik;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_3_react__["Children"].count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_7_lodash_es_toPath__["a" /* default */])(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  } // check if path is not in the end


  if (p !== path.length && !obj) {
    return def;
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_clone__["a" /* default */])(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = Object(__WEBPACK_IMPORTED_MODULE_7_lodash_es_toPath__["a" /* default */])(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_clone__["a" /* default */])(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(props.initialValues);
  var initialErrors = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(props.initialErrors || emptyErrors);
  var initialTouched = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(props.initialTouched || emptyTouched);
  var initialStatus = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(props.initialStatus);
  var isMounted = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
  var fieldRegistry = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])({});

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? invariant(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(0),
      setIteration = _React$useState[1];

  var stateRef = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])({
    values: Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_cloneDeep__["a" /* default */])(props.initialValues),
    errors: Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_cloneDeep__["a" /* default */])(props.initialErrors) || emptyErrors,
    touched: Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_cloneDeep__["a" /* default */])(props.initialTouched) || emptyTouched,
    status: Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_cloneDeep__["a" /* default */])(props.initialStatus),
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  });
  var state = stateRef.current;
  var dispatch = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (action) {
    var prev = stateRef.current;
    stateRef.current = formikReducer(prev, action); // force rerender

    if (prev !== stateRef.current) setIteration(function (x) {
      return x + 1;
    });
  }, []);
  var runValidateHandler = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = __WEBPACK_IMPORTED_MODULE_0_deepmerge__["a" /* default */].all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (validateOnMount && isMounted.current === true && __WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched, props.onReset]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();

        if (validateOnMount) {
          validateFormWithHighPriority(initialValues.current);
        }
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: getIn(error, name)
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: resolvedValue
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
  });
  var executeChange = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : invariant(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return !__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"])(innerRef, function () {
    return formikbag;
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? invariant(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(FormikProvider, {
    value: formikbag
  }, component ? Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_3_react__["Children"].only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  var normalizedValues = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
    abortEarly: false,
    context: context || normalizedValues
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? Object(__WEBPACK_IMPORTED_MODULE_0_deepmerge__["a" /* default */])(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = Object(__WEBPACK_IMPORTED_MODULE_0_deepmerge__["a" /* default */])(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_3_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"];

function useEventCallback(fn) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return Object(__WEBPACK_IMPORTED_MODULE_3_react__["useCallback"])(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {
    !formik ? process.env.NODE_ENV !== "production" ? invariant(false, 'useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component') : invariant(false) : void 0;
  }

  !fieldName ?  false ? invariant(false, 'Invalid field name. Either pass `useField` a string or an object containing a `name` key.') : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
  var fieldHelpers = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
    return getFieldHelpers(fieldName);
  }, [getFieldHelpers, fieldName]);
  return [getFieldProps(props), getFieldMeta(fieldName), fieldHelpers];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component", "className"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!render ? process.env.NODE_ENV !== "production" ? invariant(false, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + name + "\" render={({field, form}) => ...} /> with <Field name=\"" + name + "\">{({field, form, meta}) => ...}</Field>") : invariant(false) : void 0;
      !!(is && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.') : invariant(false) : void 0;
      !!(component && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : invariant(false) : void 0;
      !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  } // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  Object(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, _extends({
        ref: innerRef
      }, field, rest, {
        className: className
      }), children);
    } // We don't pass `meta` for backwards compat


    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, _extends({
      field: field,
      form: formik
    }, props, {
      className: className
    }), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(asElement, _extends({
      ref: _innerRef
    }, field, _rest, {
      className: className
    }), children);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(asElement, _extends({}, field, props, {
    className: className
  }), children);
}

var Form = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"])(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])("form", _extends({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C = /*#__PURE__*/function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };

        _this.renderFormComponent = function (formikProps) {
          return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(Component$1, _extends({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(Formik, _extends({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default()(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? invariant(false, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + Comp.name) : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(Comp, _extends({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default()(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
  var fn = typeof alteration === 'function' ? alteration : defaultFunction;
  return function (data) {
    if (Array.isArray(data) || isObject(data)) {
      var clone = copyArrayLike(data);
      return fn(clone);
    } // This can be assumed to be a primitive, which
    // is a case for top level validation errors


    return data;
  };
};

var FieldArrayInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = createAlterationHandler(alterErrors, fn);
        var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_cloneDeep__["a" /* default */])(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];
        length = arr.length;
        return arr;
      }, function (array) {
        return array ? [null].concat(array) : [null];
      }, function (array) {
        return array ? [null].concat(array) : [null];
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    };

    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.validateOnChange && this.props.formik.validateOnChange && !__WEBPACK_IMPORTED_MODULE_4_react_fast_compare___default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      } // if the array only includes undefined values we have to return an empty array


      return isFunction(copy.every) ? copy.every(function (v) {
        return v === undefined;
      }) ? [] : copy : copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array.slice();

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_3_react__["Children"].only(children) : null : null;
  };

  return FieldArrayInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray = /*#__PURE__*/connect(FieldArrayInner);

var ErrorMessageImpl = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

var ErrorMessage = /*#__PURE__*/connect(ErrorMessageImpl);

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var FastFieldInner = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? invariant(false, "<FastField render> has been deprecated. Please use a child callback function instead: <FastField name={" + name + "}>{props => ...}</FastField> instead.") : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
    !!(component && render) ?  false ? invariant(false, 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored') : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
    !!(is && children && isFunction(children)) ?  false ? invariant(false, 'You should not use <FastField as> and <FastField children> as a function in the same <FastField> component; <FastField as> will be ignored.') : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
    !!(component && children && isFunction(children)) ?  false ? invariant(false, 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.') : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
    !!(render && children && !isEmptyChildren(children)) ?  false ? invariant(false, 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored') : Object(__WEBPACK_IMPORTED_MODULE_5_tiny_warning__["a" /* default */])(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = formik.getFieldProps(_extends({
      name: name
    }, props));
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, _extends({
          ref: innerRef
        }, field, rest), children);
      } // We don't pass `meta` for backwards compat


      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(asElement, _extends({
        ref: _innerRef
      }, field, _rest), children);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(asElement, _extends({}, field, props), children);
  };

  return FastFieldInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

var FastField = /*#__PURE__*/connect(FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),

/***/ 5786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(329);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 5787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenAccessibe = void 0;
exports.initializeAccessibe = initializeAccessibe;
exports.enableAccessibe = enableAccessibe;
exports.pollToOpenAccessibe = pollToOpenAccessibe;
var react_1 = __webpack_require__(0);
var accessibeLocalStorageKey = 'do_load_accesibe_js';
function initializeAccessibe() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (window.acsbJS) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, new Promise(function (resolve) {
                            var script = document.createElement('script');
                            script.onload = resolve;
                            script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
                            script.async = true;
                            document.body.appendChild(script);
                        })];
                case 1:
                    _a.sent();
                    window.acsbJS.init({
                        statementLink: '',
                        footerHtml: 'Web Accessibility Settings',
                        hideMobile: false,
                        hideTrigger: false,
                        language: 'en',
                        position: 'left',
                        leadColor: '#282827',
                        triggerColor: '#fc5647',
                        triggerRadius: '50%',
                        triggerPositionX: 'left',
                        triggerPositionY: 'bottom',
                        triggerIcon: 'people',
                        triggerSize: 'medium',
                        triggerOffsetX: 20,
                        triggerOffsetY: 20,
                        mobile: {
                            triggerSize: 'small',
                            triggerPositionX: 'left',
                            triggerPositionY: 'bottom',
                            triggerOffsetX: 20,
                            triggerOffsetY: 20,
                            triggerRadius: '50%',
                        },
                    });
                    return [2 /*return*/];
            }
        });
    });
}
function enableAccessibe() {
    window.localStorage.setItem(accessibeLocalStorageKey, 'yes');
    return initializeAccessibe();
}
function pollToOpenAccessibe() {
    var checkExist = setInterval(function () {
        var acessibeTrigger = document.querySelector('.acsb-trigger');
        if (acessibeTrigger instanceof HTMLElement) {
            acessibeTrigger.click();
            window.clearInterval(checkExist);
        }
    }, 100);
}
var useOpenAccessibe = function () {
    (0, react_1.useEffect)(function () {
        if (typeof window !== 'undefined' &&
            window.localStorage.getItem(accessibeLocalStorageKey) === 'yes') {
            initializeAccessibe();
        }
    }, []);
    return (0, react_1.useCallback)(function () {
        if (typeof window !== 'undefined') {
            enableAccessibe();
            pollToOpenAccessibe();
        }
    }, []);
};
exports.useOpenAccessibe = useOpenAccessibe;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 5788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickOutside = useOnClickOutside;
exports.useOnGlobalKeyDown = useOnGlobalKeyDown;
exports.useOnGlobalKeyUp = useOnGlobalKeyUp;
var react_1 = __webpack_require__(0);
function useOnClickOutside(insideRef, onOutsideClick) {
    (0, react_1.useEffect)(function () {
        var handleClick = function (e) {
            if (insideRef.current &&
                e.target instanceof Element &&
                !insideRef.current.contains(e.target) &&
                // Click-dragging can result in an outside click that doesn't shift focus. In this case onOutsideClick shoudn't be fired
                !insideRef.current.contains(document.activeElement)) {
                onOutsideClick();
            }
        };
        document.addEventListener('click', handleClick);
        return function () { return document.removeEventListener('click', handleClick); };
    }, [insideRef, onOutsideClick]);
}
function useOnGlobalKeyDown(keyWhitelist, onKeyDown) {
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (e) {
            if (keyWhitelist.includes(e.key)) {
                onKeyDown(e);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () { return document.removeEventListener('keydown', handleKeyDown); };
    }, [onKeyDown, keyWhitelist]);
}
function useOnGlobalKeyUp(keyWhitelist, onKeyUp) {
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (e) {
            if (keyWhitelist.includes(e.key)) {
                onKeyUp(e);
            }
        };
        document.addEventListener('keyup', handleKeyDown);
        return function () { return document.removeEventListener('keyup', handleKeyDown); };
    }, [onKeyUp, keyWhitelist]);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 5789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsMounted = void 0;
var react_1 = __webpack_require__(0);
var useIsMounted = function () {
    var isMounted = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(function () {
        isMounted.current = true;
        return function () {
            isMounted.current = false;
        };
    }, []);
    return (0, react_1.useCallback)(function () { return isMounted.current; }, []);
};
exports.useIsMounted = useIsMounted;
exports.default = exports.useIsMounted;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlSXNNb3VudGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vdXNlSXNNb3VudGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtCQUF1RDtBQUVoRCxJQUFNLFlBQVksR0FBRztJQUMxQixJQUFNLFNBQVMsR0FBRyxJQUFBLGNBQU0sRUFBQyxJQUFJLENBQUMsQ0FBQztJQUMvQixJQUFBLGlCQUFTLEVBQUM7UUFDUixTQUFTLENBQUMsT0FBTyxHQUFHLElBQUksQ0FBQztRQUN6QixPQUFPO1lBQ0wsU0FBUyxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUM7UUFDNUIsQ0FBQyxDQUFDO0lBQ0osQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsT0FBTyxJQUFBLG1CQUFXLEVBQUMsY0FBTSxPQUFBLFNBQVMsQ0FBQyxPQUFPLEVBQWpCLENBQWlCLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDbEQsQ0FBQyxDQUFDO0FBVlcsUUFBQSxZQUFZLGdCQVV2QjtBQUVGLGtCQUFlLG9CQUFZLENBQUMifQ==

/***/ }),

/***/ 5790:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMedia = useMedia;
var react_1 = __webpack_require__(0);
/**
 * Determines whether or not the `media query` denoted by the provided `mediaQueryString`
 * is satisfied
 * @param mediaQueryString
 */
function useMedia(mediaQueryString) {
    var _a = __read((0, react_1.useState)(false), 2), matches = _a[0], setMatches = _a[1];
    (0, react_1.useEffect)(function () {
        var mediaQueryList = window.matchMedia(mediaQueryString);
        setMatches(mediaQueryList.matches);
        var handleChange = function (e) { return setMatches(e.matches); };
        mediaQueryList.addEventListener('change', handleChange);
        return function () { return mediaQueryList.removeEventListener('change', handleChange); };
    }, [mediaQueryString]);
    return matches;
}
exports.default = useMedia;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLW1lZGlhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vdXNlLW1lZGlhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQU9BLDRCQWNDO0FBckJELCtCQUE0QztBQUU1Qzs7OztHQUlHO0FBQ0gsU0FBZ0IsUUFBUSxDQUFDLGdCQUF3QjtJQUN6QyxJQUFBLEtBQUEsT0FBd0IsSUFBQSxnQkFBUSxFQUFDLEtBQUssQ0FBQyxJQUFBLEVBQXRDLE9BQU8sUUFBQSxFQUFFLFVBQVUsUUFBbUIsQ0FBQztJQUU5QyxJQUFBLGlCQUFTLEVBQUM7UUFDUixJQUFNLGNBQWMsR0FBRyxNQUFNLENBQUMsVUFBVSxDQUFDLGdCQUFnQixDQUFDLENBQUM7UUFDM0QsVUFBVSxDQUFDLGNBQWMsQ0FBQyxPQUFPLENBQUMsQ0FBQztRQUVuQyxJQUFNLFlBQVksR0FBRyxVQUFDLENBQXNCLElBQUssT0FBQSxVQUFVLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxFQUFyQixDQUFxQixDQUFDO1FBQ3ZFLGNBQWMsQ0FBQyxnQkFBZ0IsQ0FBQyxRQUFRLEVBQUUsWUFBWSxDQUFDLENBQUM7UUFFeEQsT0FBTyxjQUFNLE9BQUEsY0FBYyxDQUFDLG1CQUFtQixDQUFDLFFBQVEsRUFBRSxZQUFZLENBQUMsRUFBMUQsQ0FBMEQsQ0FBQztJQUMxRSxDQUFDLEVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDLENBQUM7SUFFdkIsT0FBTyxPQUFPLENBQUM7QUFDakIsQ0FBQztBQUVELGtCQUFlLFFBQVEsQ0FBQyJ9

/***/ }),

/***/ 5791:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Track = void 0;
var react_1 = __importStar(__webpack_require__(0));
var trackEvent_1 = __webpack_require__(1554);
var trackingContext_1 = __webpack_require__(2556);
var defaultTrackProps = {
    enableTracking: false,
    pageName: 'Default Page Name',
    useClassName: false,
};
var Track = function (props) {
    var children = props.children, eventName = props.eventName, trackingProps = props.trackingProps, trackingMetadata = props.trackingMetadata;
    var trackingContext = (0, trackingContext_1.useTrackingContext)();
    function usePrevious(value) {
        var ref = (0, react_1.useRef)();
        (0, react_1.useEffect)(function () {
            ref.current = value;
        }, [value]);
        return ref.current;
    }
    function useCompareComponentTitle(componentTitle) {
        var prevcomponentTitle = usePrevious(componentTitle);
        var trackingPropsWithDefaults = __assign(__assign({}, defaultTrackProps), trackingProps);
        if (prevcomponentTitle !== componentTitle) {
            (0, trackEvent_1.trackEvent)({
                children: children,
                trackingProps: trackingPropsWithDefaults,
                eventName: eventName,
                trackingMetadata: trackingMetadata,
                trackingContext: trackingContext,
            });
        }
    }
    function useCompareError(error) {
        var prevError = usePrevious(error);
        var trackingPropsWithDefaults = __assign(__assign({}, defaultTrackProps), trackingProps);
        if (prevError !== error) {
            (0, trackEvent_1.trackEvent)({
                children: children,
                trackingProps: trackingPropsWithDefaults,
                eventName: eventName,
                trackingMetadata: trackingMetadata,
                trackingContext: trackingContext,
            });
        }
    }
    useCompareComponentTitle(trackingProps.componentTitle);
    useCompareError(trackingProps.errorString);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Track = Track;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHJhY2suanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9UcmFjay50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSw2Q0FBaUQ7QUFNakQsMkNBQTBDO0FBQzFDLHFEQUF1RDtBQVN2RCxJQUFNLGlCQUFpQixHQUFHO0lBQ3hCLGNBQWMsRUFBRSxLQUFLO0lBQ3JCLFFBQVEsRUFBRSxtQkFBbUI7SUFDN0IsWUFBWSxFQUFFLEtBQUs7Q0FDcEIsQ0FBQztBQUVLLElBQU0sS0FBSyxHQUFHLFVBQUMsS0FBaUI7SUFDN0IsSUFBQSxRQUFRLEdBQWlELEtBQUssU0FBdEQsRUFBRSxTQUFTLEdBQXNDLEtBQUssVUFBM0MsRUFBRSxhQUFhLEdBQXVCLEtBQUssY0FBNUIsRUFBRSxnQkFBZ0IsR0FBSyxLQUFLLGlCQUFWLENBQVc7SUFDdkUsSUFBTSxlQUFlLEdBQUcsSUFBQSxvQ0FBa0IsR0FBRSxDQUFDO0lBRTdDLFNBQVMsV0FBVyxDQUFDLEtBQXlCO1FBQzVDLElBQU0sR0FBRyxHQUFHLElBQUEsY0FBTSxHQUFVLENBQUM7UUFDN0IsSUFBQSxpQkFBUyxFQUFDO1lBQ1IsR0FBRyxDQUFDLE9BQU8sR0FBRyxLQUFLLENBQUM7UUFDdEIsQ0FBQyxFQUFFLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQztRQUNaLE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQztJQUNyQixDQUFDO0lBRUQsU0FBUyx3QkFBd0IsQ0FBQyxjQUFrQztRQUNsRSxJQUFNLGtCQUFrQixHQUFHLFdBQVcsQ0FBQyxjQUFjLENBQUMsQ0FBQztRQUN2RCxJQUFNLHlCQUF5Qix5QkFDMUIsaUJBQWlCLEdBQ2pCLGFBQWEsQ0FDakIsQ0FBQztRQUNGLElBQUksa0JBQWtCLEtBQUssY0FBYyxFQUFFLENBQUM7WUFDMUMsSUFBQSx1QkFBVSxFQUFDO2dCQUNULFFBQVEsVUFBQTtnQkFDUixhQUFhLEVBQUUseUJBQXlCO2dCQUN4QyxTQUFTLFdBQUE7Z0JBQ1QsZ0JBQWdCLGtCQUFBO2dCQUNoQixlQUFlLGlCQUFBO2FBQ2hCLENBQUMsQ0FBQztRQUNMLENBQUM7SUFDSCxDQUFDO0lBRUQsU0FBUyxlQUFlLENBQUMsS0FBeUI7UUFDaEQsSUFBTSxTQUFTLEdBQUcsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ3JDLElBQU0seUJBQXlCLHlCQUMxQixpQkFBaUIsR0FDakIsYUFBYSxDQUNqQixDQUFDO1FBQ0YsSUFBSSxTQUFTLEtBQUssS0FBSyxFQUFFLENBQUM7WUFDeEIsSUFBQSx1QkFBVSxFQUFDO2dCQUNULFFBQVEsVUFBQTtnQkFDUixhQUFhLEVBQUUseUJBQXlCO2dCQUN4QyxTQUFTLFdBQUE7Z0JBQ1QsZ0JBQWdCLGtCQUFBO2dCQUNoQixlQUFlLGlCQUFBO2FBQ2hCLENBQUMsQ0FBQztRQUNMLENBQUM7SUFDSCxDQUFDO0lBRUQsd0JBQXdCLENBQUMsYUFBYSxDQUFDLGNBQWMsQ0FBQyxDQUFDO0lBQ3ZELGVBQWUsQ0FBQyxhQUFhLENBQUMsV0FBVyxDQUFDLENBQUM7SUFFM0MseURBQXlEO0lBQ3pELE9BQU8sNkRBQUssQ0FBQztBQUNmLENBQUMsQ0FBQztBQW5EVyxRQUFBLEtBQUssU0FtRGhCIn0=

/***/ }),

/***/ 5792:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.formatErrorString = void 0;
var trackEvent_1 = __webpack_require__(1554);
var formatErrorString = function (message) {
    var formattedErrorString = (0, trackEvent_1.formatChildren)(message);
    if (formattedErrorString === '') {
        return 'Default Error String';
    }
    return formattedErrorString;
};
exports.formatErrorString = formatErrorString;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0RXJyb3JTdHJpbmcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9mb3JtYXRFcnJvclN0cmluZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwyQ0FBOEM7QUFFdkMsSUFBTSxpQkFBaUIsR0FBRyxVQUFDLE9BQStCO0lBQy9ELElBQU0sb0JBQW9CLEdBQUcsSUFBQSwyQkFBYyxFQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ3JELElBQUksb0JBQW9CLEtBQUssRUFBRSxFQUFFLENBQUM7UUFDaEMsT0FBTyxzQkFBc0IsQ0FBQztJQUNoQyxDQUFDO0lBRUQsT0FBTyxvQkFBb0IsQ0FBQztBQUM5QixDQUFDLENBQUM7QUFQVyxRQUFBLGlCQUFpQixxQkFPNUIifQ==

/***/ }),

/***/ 5793:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __webpack_require__(0);
var uniqueId_1 = __importDefault(__webpack_require__(5794));
// React.useId is a SSR safe way of generating unique ids, but is only available in React 18+. Until we upgrade all
// consuming apps to use React 18+, we need a fallback to lodash/uniqueId.
// The prefix argument is only used necessary for apps using React 17.
var useUniqueId = function (prefix) {
    if (typeof react_1.useId === 'function') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, react_1.useId)();
    }
    // Fallback to lodash/uniqueId
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)("".concat(prefix, "-"))), 1), id = _a[0];
    return id;
};
exports.default = useUniqueId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLXVuaXF1ZS1pZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3VzZS11bmlxdWUtaWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsK0JBQXdDO0FBQ3hDLDZEQUF3QztBQUV4QyxtSEFBbUg7QUFDbkgsMEVBQTBFO0FBQzFFLHNFQUFzRTtBQUN0RSxJQUFNLFdBQVcsR0FBRyxVQUFDLE1BQWU7SUFDbEMsSUFBSSxPQUFPLGFBQUssS0FBSyxVQUFVLEVBQUUsQ0FBQztRQUNoQyxzREFBc0Q7UUFDdEQsT0FBTyxJQUFBLGFBQUssR0FBRSxDQUFDO0lBQ2pCLENBQUM7SUFDRCw4QkFBOEI7SUFDOUIsc0RBQXNEO0lBQ2hELElBQUEsS0FBQSxPQUFPLElBQUEsZ0JBQVEsRUFBQyxJQUFBLGtCQUFTLEVBQUMsVUFBRyxNQUFNLE1BQUcsQ0FBQyxDQUFDLElBQUEsRUFBdkMsRUFBRSxRQUFxQyxDQUFDO0lBQy9DLE9BQU8sRUFBRSxDQUFDO0FBQ1osQ0FBQyxDQUFDO0FBRUYsa0JBQWUsV0FBVyxDQUFDIn0=

/***/ }),

/***/ 5794:
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(5795);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 5795:
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(5796);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 5796:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1555),
    arrayMap = __webpack_require__(5799),
    isArray = __webpack_require__(5800),
    isSymbol = __webpack_require__(5801);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 5797:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(5798);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 5798:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)))

/***/ }),

/***/ 5799:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 5800:
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 5801:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(5802),
    isObjectLike = __webpack_require__(5805);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 5802:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1555),
    getRawTag = __webpack_require__(5803),
    objectToString = __webpack_require__(5804);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 5803:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1555);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 5804:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5805:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 5806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = exports.NAME = void 0;
exports.NAME = '@angi/button';
exports.VERSION = '3.2.3';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0YWRhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9tZXRhZGF0YS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLElBQUksR0FBRyxjQUFjLENBQUM7QUFDdEIsUUFBQSxPQUFPLEdBQUcsT0FBTyxDQUFDIn0=

/***/ }),

/***/ 5807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaGroup = void 0;
var react_1 = __importDefault(__webpack_require__(0));
var clsx_1 = __importDefault(__webpack_require__(499));
var Button_1 = __webpack_require__(2552);
var CtaGroup_module_css_1 = __importDefault(__webpack_require__(5808));
var CtaGroup = function (_a) {
    var primaryButton = _a.primaryButton, secondaryButton = _a.secondaryButton, linkButton = _a.linkButton, _b = _a.orientation, orientation = _b === void 0 ? 'vertical' : _b, className = _a.className, _c = _a.stickyStyling, stickyStyling = _c === void 0 ? false : _c, _d = _a.stickyTall, stickyTall = _d === void 0 ? false : _d, ctaContainerClassName = _a.ctaContainerClassName, divProps = __rest(_a, ["primaryButton", "secondaryButton", "linkButton", "orientation", "className", "stickyStyling", "stickyTall", "ctaContainerClassName"]);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)(className, stickyStyling && CtaGroup_module_css_1.default.rootTopBorder) },
        react_1.default.createElement("div", __assign({}, divProps, { className: (0, clsx_1.default)(CtaGroup_module_css_1.default.ctaGroup, ctaContainerClassName, CtaGroup_module_css_1.default[orientation], stickyStyling && CtaGroup_module_css_1.default.stickyStyling, stickyStyling && stickyTall && CtaGroup_module_css_1.default.stickyTall) }),
            react_1.default.createElement(Button_1.Button, __assign({}, primaryButton)),
            secondaryButton && (react_1.default.createElement(Button_1.Button, __assign({ variant: "secondary", className: (0, clsx_1.default)(secondaryButton.className, CtaGroup_module_css_1.default.secondaryButton) }, secondaryButton))),
            linkButton && (react_1.default.createElement(Button_1.Button, __assign({ variant: "link", className: (0, clsx_1.default)(linkButton.className, CtaGroup_module_css_1.default.linkButton) }, linkButton))))));
};
exports.CtaGroup = CtaGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3RhR3JvdXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9DdGFHcm91cC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdEQUEwQjtBQUMxQiw4Q0FBd0I7QUFDeEIsbUNBQWtDO0FBRWxDLDhFQUEyQztBQTBDcEMsSUFBTSxRQUFRLEdBQUcsVUFBQyxFQVVUO0lBVGQsSUFBQSxhQUFhLG1CQUFBLEVBQ2IsZUFBZSxxQkFBQSxFQUNmLFVBQVUsZ0JBQUEsRUFDVixtQkFBd0IsRUFBeEIsV0FBVyxtQkFBRyxVQUFVLEtBQUEsRUFDeEIsU0FBUyxlQUFBLEVBQ1QscUJBQXFCLEVBQXJCLGFBQWEsbUJBQUcsS0FBSyxLQUFBLEVBQ3JCLGtCQUFrQixFQUFsQixVQUFVLG1CQUFHLEtBQUssS0FBQSxFQUNsQixxQkFBcUIsMkJBQUEsRUFDbEIsUUFBUSxjQVRZLHNJQVV4QixDQURZO0lBRVgsT0FBTyxDQUNMLHVDQUFLLFNBQVMsRUFBRSxJQUFBLGNBQUksRUFBQyxTQUFTLEVBQUUsYUFBYSxJQUFJLDZCQUFNLENBQUMsYUFBYSxDQUFDO1FBQ3BFLGtEQUNNLFFBQVEsSUFDWixTQUFTLEVBQUUsSUFBQSxjQUFJLEVBQ2IsNkJBQU0sQ0FBQyxRQUFRLEVBQ2YscUJBQXFCLEVBQ3JCLDZCQUFNLENBQUMsV0FBVyxDQUFDLEVBQ25CLGFBQWEsSUFBSSw2QkFBTSxDQUFDLGFBQWEsRUFDckMsYUFBYSxJQUFJLFVBQVUsSUFBSSw2QkFBTSxDQUFDLFVBQVUsQ0FDakQ7WUFFRCw4QkFBQyxlQUFNLGVBQUssYUFBYSxFQUFJO1lBQzVCLGVBQWUsSUFBSSxDQUNsQiw4QkFBQyxlQUFNLGFBQ0wsT0FBTyxFQUFDLFdBQVcsRUFDbkIsU0FBUyxFQUFFLElBQUEsY0FBSSxFQUFDLGVBQWUsQ0FBQyxTQUFTLEVBQUUsNkJBQU0sQ0FBQyxlQUFlLENBQUMsSUFDOUQsZUFBZSxFQUNuQixDQUNIO1lBQ0EsVUFBVSxJQUFJLENBQ2IsOEJBQUMsZUFBTSxhQUNMLE9BQU8sRUFBQyxNQUFNLEVBQ2QsU0FBUyxFQUFFLElBQUEsY0FBSSxFQUFDLFVBQVUsQ0FBQyxTQUFTLEVBQUUsNkJBQU0sQ0FBQyxVQUFVLENBQUMsSUFDcEQsVUFBVSxFQUNkLENBQ0gsQ0FDRyxDQUNGLENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQXpDVyxRQUFBLFFBQVEsWUF5Q25CIn0=

/***/ }),

/***/ 5808:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5809:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5810:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExclamatoryIcon */
/* unused harmony export WarningIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppraisersIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _svg, _svg2, _svg3;


var ExclamatoryIcon = function ExclamatoryIcon() {
  return _svg || (_svg = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "60",
    height: "30",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    fill: "white"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7Z",
    fill: "#D71100"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M13.25 16.75C13.25 17.4404 12.6904 18 12 18C11.3096 18 10.75 17.4404 10.75 16.75C10.75 16.0596 11.3096 15.5 12 15.5C12.6904 15.5 13.25 16.0596 13.25 16.75Z",
    fill: "#D71100"
  })));
};
var WarningIcon = function WarningIcon() {
  return _svg2 || (_svg2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "28",
    cy: "28",
    r: "28",
    fill: "#E8FDF2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1455 39.2038H17.8478C17.0495 39.2038 16.3047 38.7669 15.9045 38.0639C15.5054 37.362 15.5054 36.4883 15.9045 35.7853L26.0534 17.9367C26.4536 17.2337 27.1994 16.7969 27.9977 16.7969C28.796 16.7969 29.5408 17.2337 29.941 17.9367L40.0096 35.6462L40.0321 35.6821C40.2686 36.0504 40.3948 36.4796 40.3948 36.9251C40.3948 38.1813 39.3857 39.2038 38.1455 39.2038ZM41.3879 34.8106L31.3311 17.1218C30.6452 15.9157 29.3685 15.167 27.9977 15.167C26.6259 15.167 25.3492 15.9157 24.6633 17.1218L14.5145 34.9703C13.8285 36.1765 13.8285 37.6749 14.5145 38.8789C15.2004 40.085 16.477 40.8337 17.8478 40.8337H38.1508C40.2729 40.8337 42 39.0799 42 36.9251C42 36.171 41.7881 35.4408 41.3879 34.8106ZM27.9993 32.1C28.6018 32.1 29.0919 31.6023 29.0919 30.9905V22.6226C29.0919 22.0109 28.6018 21.5132 27.9993 21.5132C27.3969 21.5132 26.9068 22.0109 26.9068 22.6226V30.9905C26.9068 31.6023 27.3969 32.1 27.9993 32.1ZM26.6448 34.8865C26.7122 34.6985 26.8299 34.5442 26.9648 34.391C27.503 33.8444 28.479 33.8444 29.0504 34.391C29.319 34.6811 29.4709 35.0571 29.4709 35.4504C29.4709 35.8427 29.319 36.236 29.0504 36.5088C28.7647 36.7826 28.3933 36.9532 28.0081 36.9532C27.6197 36.9532 27.2344 36.7826 26.9648 36.5088C26.6951 36.236 26.5282 35.8427 26.5282 35.4504C26.5282 35.2613 26.5603 35.0744 26.6448 34.8865Z",
    fill: "#333333"
  })));
}; // This icon is a copy of Appraisers from service-and-category-icon in fe-monorepo.
// It's created locally here as tailwind doesn't play nice in thunderball app.

var AppraisersIcon = function AppraisersIcon() {
  return _svg3 || (_svg3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    width: "72",
    height: "72",
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M41.2995 22.5L49.6994 30.8999L23.0998 57.4995C20.7802 59.819 17.0195 59.819 14.6999 57.4995C12.3803 55.1799 12.3803 51.4192 14.6999 49.0996L41.2995 22.5Z",
    fill: "#8CF4BE"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M27.825 36L36.1937 44.4309L28.6063 51.9624L28.0311 46.3789C27.751 43.6594 26.5506 41.1171 24.6286 39.1728L27.825 36Z",
    fill: "#003359"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "43.4999",
    cy: "28.5",
    r: "19.5",
    fill: "#003359"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: "43.5",
    cy: "28.4999",
    r: "16.5",
    fill: "#8CF4BE"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M31.5 28.5L43.5 18L55.5 28.5H51V37.5H36V28.5H31.5Z",
    fill: "#003359"
  })));
};

/***/ }),

/***/ 5812:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5813:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FlatListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BusinessCard__ = __webpack_require__(2559);


var FlatListComponent = function FlatListComponent(props) {
  var onCardClicked = props.onCardClicked,
      serviceProviders = props.serviceProviders,
      productInfoFeatureFlag = props.productInfoFeatureFlag;
  var sps = serviceProviders || [];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "business-list"
  }, sps.map(function (sp) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__BusinessCard__["a" /* default */], {
      key: sp.id,
      sp: sp,
      onCardClicked: onCardClicked,
      productInfoFeatureFlag: productInfoFeatureFlag
    });
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (FlatListComponent);

/***/ }),

/***/ 5815:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__angi_url_catalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelpFooter_scss__ = __webpack_require__(5817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HelpFooter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HelpFooter_scss__);
var _div, _div2;






var HelpFooter = function HelpFooter() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "businesslist-help-container"
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-title"
  }, "Not seeing the business you\u2019re trying to manage?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-description-container"
  }, _div2 || (_div2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-description"
  }, " Learn how to manage all of your businesses with one email", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["Track"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    href: "https://intercom.help/angi/en/articles/11066470-use-a-single-sign-in-to-manage-multiple-businesses",
    id: "intercom-link",
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, " here."))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "help-description"
  }, "Or, call us at", /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["Track"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", {
    href: __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog___default.a.global.customerCarePhone(),
    id: "phone"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong", null, " ", __WEBPACK_IMPORTED_MODULE_0__angi_url_catalog___default.a.global.customerCarePhoneText(), ". "))), "Monday-Friday 8AM-8PM ET and Saturday 9AM-3PM ET.")));
};

/* harmony default export */ __webpack_exports__["a"] = (HelpFooter);

/***/ }),

/***/ 5817:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CategorizedListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategorizedList_scss__ = __webpack_require__(5819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CategorizedList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CategorizedList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BusinessCard__ = __webpack_require__(2559);





var getRegion = function getRegion() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$region = _ref.region,
      region = _ref$region === void 0 ? {} : _ref$region;

  return region.name;
};

var renderInfoPanel = function renderInfoPanel(letter, sps, onCardClicked, productInfoFeatureFlag) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "letter-section",
    key: letter
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "letter-header"
  }, letter), sps.map(function (sp) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__BusinessCard__["a" /* default */], {
      key: sp.id,
      sp: sp,
      onCardClicked: onCardClicked,
      productInfoFeatureFlag: productInfoFeatureFlag
    });
  }));
};

var byState = function byState(value) {
  return getRegion(value.primaryAddress);
};

var byName = function byName(value) {
  return value.name.charAt(0).toUpperCase();
};

var getSortField = function getSortField(field) {
  switch (field) {
    case 'state':
      return byState;

    case 'name':
    default:
      return byName;
  }
};

var CategorizedListComponent = function CategorizedListComponent(props) {
  var sortField = props.sortField,
      onCardClicked = props.onCardClicked,
      serviceProviders = props.serviceProviders,
      productInfoFeatureFlag = props.productInfoFeatureFlag;
  var sps = serviceProviders || [];
  var letterToSps = sps.reduce(function (acc, value) {
    var key = getSortField(sortField)(value);

    if (!acc[key]) {
      acc[key] = [];
    }

    acc[key].push(value);
    return acc;
  }, {});
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, Object.entries(letterToSps).map(function (_ref2) {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
        l = _ref3[0],
        orderedSps = _ref3[1];

    return renderInfoPanel(l, orderedSps, onCardClicked, productInfoFeatureFlag);
  }));
};
/* harmony default export */ __webpack_exports__["a"] = (CategorizedListComponent);

/***/ }),

/***/ 5819:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BottomDrawerModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BottomDrawerModal_scss__ = __webpack_require__(5821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BottomDrawerModal_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__BottomDrawerModal_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Options__ = __webpack_require__(2557);



var _div, _div2;




 // eslint-disable-next-line import/no-named-as-default


var BottomDrawerModal = function BottomDrawerModal(props) {
  var closeDrawer = props.closeDrawer,
      optionProps = props.optionProps;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(false),
      _useState2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      openOptions = _useState2[0],
      setOpenOptions = _useState2[1];

  var domNode = document.getElementsByClassName('site-container')[0];
  Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
    setTimeout(function () {
      return setOpenOptions(props.open);
    }, 0);

    if (props.open) {
      domNode.style.overflow = 'hidden';
    } else {
      domNode.style.overflow = 'auto';
    }
  }, [props.open]);

  var closeModal = function closeModal() {
    setOpenOptions(false);
    setTimeout(function () {
      return closeDrawer(false);
    }, 600);
    domNode.style.overflow = 'auto';
  };

  return props.open ?
  /*#__PURE__*/
  // eslint-disable-next-line function-paren-newline
  Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "bottom-drawer"
  }, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "drawer-backdrop"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('drawer-content', {
      open: openOptions
    })
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "close-modal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "drawer-header"
  }, _div2 || (_div2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: "drawer-header-title"
  }, "Sort")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("i", {
    className: "icon icon-close",
    role: "button",
    tabIndex: 0,
    onClick: closeModal,
    onKeyDown: closeModal
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Options__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
    closeFilter: closeModal
  }, optionProps)))), domNode) : null;
};
/* harmony default export */ __webpack_exports__["a"] = (BottomDrawerModal);

/***/ }),

/***/ 5821:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export UnifiedBusinessListViewComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hot_loader__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__unifiedBusinessListView_scss__ = __webpack_require__(5823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__unifiedBusinessListView_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__unifiedBusinessListView_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_BusinessList__ = __webpack_require__(5824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(229);







var _div, _BusinessList;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(derived);
  return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(_this).constructor) : derived.apply(_this, args));
}












var prosPerPage = 20;
var UnifiedBusinessListViewComponent = /*#__PURE__*/function (_React$Component) {
  function UnifiedBusinessListViewComponent() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, UnifiedBusinessListViewComponent);

    return _callSuper(this, UnifiedBusinessListViewComponent, arguments);
  }

  __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_inherits___default()(UnifiedBusinessListViewComponent, _React$Component);

  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(UnifiedBusinessListViewComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var getCurrentUsersServiceProviders = this.props.getCurrentUsersServiceProviders; // TODO make prosPerPage an API limit

      getCurrentUsersServiceProviders({
        offset: 0,
        limit: prosPerPage,
        sortBy: 'name'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$businessL = this.props.businessList.getCurrentUsersServiceProviders,
          request = _this$props$businessL.request,
          response = _this$props$businessL.response,
          error = _this$props$businessL.error;

      var _ref = response || {},
          _ref$serviceProviders = _ref.serviceProviders,
          serviceProviders = _ref$serviceProviders === void 0 ? [] : _ref$serviceProviders;

      var _ref2 = request || {},
          _ref2$offset = _ref2.offset,
          offset = _ref2$offset === void 0 ? 0 : _ref2$offset;

      var showBusinessList = offset > 0 || serviceProviders.length > 1 && offset === 0;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: ".business-list--unified-view-centering"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_angieslist_react_components_lib_Grid___default.a, {
        className: "business-list--grid"
      }, !showBusinessList ? [error ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Alert___default.a, {
        bsStyle: "danger",
        key: "0"
      }, Object(__WEBPACK_IMPORTED_MODULE_13_angieslist_app_platform__["getErrorMessage"])(error)) : null, _div || (_div = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "text-center",
        key: "1"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("i", {
        className: "icon icon-load text-primary icon-pulse icon-5x text-center"
      })))] : _BusinessList || (_BusinessList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_BusinessList__["a" /* default */], null))));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_hot_loader__["hot"])(module)(__WEBPACK_IMPORTED_MODULE_6_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["connect"])(function (state) {
  return {
    businessList: state.businessList
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__["default"])), __WEBPACK_IMPORTED_MODULE_7_recompose_pure___default.a)(UnifiedBusinessListViewComponent)));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46)(module)))

/***/ }),

/***/ 5823:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BusinessListComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__ = __webpack_require__(5825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_recompose_pure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddedBusinessHandler__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_browser_BusinessInfoPanel__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__businessList_scss__ = __webpack_require__(5829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__businessList_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__businessList_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__businessListAnalytics__ = __webpack_require__(5830);



var _small, _option, _option2, _option3, _option4, _AddedBusinessHandler, _i;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var prosPerPage = 20;
var activityLocation = 'SP : Business List';

var renderInfoPanel = function renderInfoPanel() {
  return function (_ref) {
    var serviceProvider = _ref.serviceProvider,
        entitlements = _ref.entitlements;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__app_browser_BusinessInfoPanel__["a" /* default */], {
      key: serviceProvider.id,
      activityLocation: activityLocation,
      showBusinessListLink: false,
      serviceProvider: serviceProvider,
      entitlements: entitlements
    });
  };
};

var renderSortDropdown = function renderSortDropdown(currentSort, getCurrentUsersServiceProviders) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "form-inline business-list--sort-container"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_angieslist_react_components_lib_Input___default.a, {
    type: "select",
    label: _small || (_small = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("small", null, "Sort by:")),
    id: "business-list--sort-by",
    value: currentSort,
    labelClassName: "sort-by-label",
    onChange: function onChange(event) {
      return getCurrentUsersServiceProviders({
        offset: 0,
        limit: prosPerPage,
        sortBy: event.target.value
      });
    }
  }, _option || (_option = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "name"
  }, "Business Name")), _option2 || (_option2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "overall_gpa"
  }, "Ratings (5-1)")), _option3 || (_option3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "overall_reviews"
  }, "Reviews")), _option4 || (_option4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("option", {
    value: "alId"
  }, "SPID"))));
};

var BusinessListComponent = function BusinessListComponent(props) {
  var _props$businessList = props.businessList,
      _props$businessList$g = _props$businessList.getCurrentUsersServiceProviders,
      request = _props$businessList$g.request,
      response = _props$businessList$g.response,
      isLoading = _props$businessList$g.isLoading,
      error = _props$businessList$g.error,
      _props$businessList$g2 = _props$businessList.getServiceProvider,
      isLoadingDetails = _props$businessList$g2.isLoading,
      errorDetails = _props$businessList$g2.error,
      serviceProviderCache = props.serviceProviderCache,
      getCurrentUsersServiceProviders = props.getCurrentUsersServiceProviders,
      userResponse = props.user.userInfo.response;

  var _ref2 = response || {},
      _ref2$serviceProvider = _ref2.serviceProviders,
      serviceProviders = _ref2$serviceProvider === void 0 ? [] : _ref2$serviceProvider,
      _ref2$total = _ref2.total,
      total = _ref2$total === void 0 ? 0 : _ref2$total;

  var _ref3 = userResponse || {},
      _ref3$entitlements = _ref3.entitlements,
      entitlements = _ref3$entitlements === void 0 ? [] : _ref3$entitlements;

  var entitlementsBySPID = __WEBPACK_IMPORTED_MODULE_1_lodash_groupBy___default()(entitlements.filter(function (e) {
    return e.scope === 'ServiceProvider';
  }), function (e) {
    return e.scopeId;
  });

  var serviceProviderDetails = serviceProviders.map(function (x) {
    return _objectSpread(_objectSpread({}, serviceProviderCache[String(x.id)]), x);
  });
  var serviceProviderDetailsWithEntitlements = serviceProviderDetails.map(function (x) {
    return {
      serviceProvider: x,
      entitlements: entitlementsBySPID["".concat(x.id)]
    };
  });

  var _ref4 = request || {},
      _ref4$limit = _ref4.limit,
      limit = _ref4$limit === void 0 ? prosPerPage : _ref4$limit,
      _ref4$offset = _ref4.offset,
      offset = _ref4$offset === void 0 ? 0 : _ref4$offset,
      _ref4$sortBy = _ref4.sortBy,
      sortBy = _ref4$sortBy === void 0 ? 'name' : _ref4$sortBy;

  var pageIndex = __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageNum(offset, limit) - 1;
  var pageCount = __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getPageCount(total, limit);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "business-list"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row___default.a, {
    className: "business-list--header-row"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default.a, {
    xs: 12,
    sm: 8
  }, serviceProviders.length > 1 ? _AddedBusinessHandler || (_AddedBusinessHandler = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__AddedBusinessHandler__["a" /* default */], null)) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h1", {
    style: {
      fontSize: 32
    }
  }, "Business List", isLoading || isLoadingDetails ? _i || (_i = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("i", {
    className: "icon icon-load text-primary icon-pulse"
  })) : null), error || errorDetails ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_angieslist_react_components_lib_Alert___default.a, {
    bsStyle: "danger"
  }, Object(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__["getErrorMessage"])(error || errorDetails)) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default.a, {
    sm: 4
  }, serviceProviders.length > 1 ? renderSortDropdown(sortBy, getCurrentUsersServiceProviders) : null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("hr", {
    className: "hidden-xs",
    style: {
      margin: '4px 0 32px 0'
    }
  }), serviceProviderDetailsWithEntitlements.map(renderInfoPanel()), pageCount > 1 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_angieslist_react_components_lib_Row___default.a, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_angieslist_react_components_lib_Col___default.a, {
    xs: 12
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_angieslist_react_components_lib_EllipsedPagination___default.a, {
    pageCount: pageCount,
    pageIndex: pageIndex,
    onChange: function onChange(index) {
      return getCurrentUsersServiceProviders({
        offset: __WEBPACK_IMPORTED_MODULE_12_angieslist_app_platform_lib_common_utils_paginationUtils___default.a.getOffset(index + 1, prosPerPage),
        limit: prosPerPage,
        sortBy: sortBy
      });
    }
  }))) : null);
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_6_angieslist_app_platform__["legacyAnalytics"])({
  ruleset: __WEBPACK_IMPORTED_MODULE_17__businessListAnalytics__["a" /* default */]
}), Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(function (state) {
  return {
    businessList: state.businessList,
    serviceProviderCache: state.serviceProviderCache,
    user: state.user
  };
}, _objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__app_common_serviceProvider_serviceProviderActions__["default"])), __WEBPACK_IMPORTED_MODULE_3_recompose_pure___default.a)(BusinessListComponent));

/***/ }),

/***/ 5825:
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(690),
    createAggregator = __webpack_require__(5826);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),

/***/ 5826:
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(5827),
    baseAggregator = __webpack_require__(5828),
    baseIteratee = __webpack_require__(206),
    isArray = __webpack_require__(118);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),

/***/ 5827:
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),

/***/ 5828:
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(490);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),

/***/ 5829:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__ = __webpack_require__(44);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ __webpack_exports__["a"] = ({
  page: {
    name: 'SP : Business List',
    properties: _objectSpread({}, __WEBPACK_IMPORTED_MODULE_1__app_browser_analyticsDefaultProperties__["b" /* defaultPageProps */])
  }
});

/***/ }),

/***/ 5831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_recompose_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_recompose_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/**
 * Functional wrapper for switching between app configs.
 * It keeps all props switching isolated to single function
 */




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_recompose_compose___default()(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state) {
  return {
    config: state.config,
    experiment: state.experimentV2
  };
}), __WEBPACK_IMPORTED_MODULE_1_recompose_setPropTypes___default()({
  config: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    appName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired
  }).isRequired,
  experiment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
})));

/***/ }),

/***/ 5832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer__ = __webpack_require__(5833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_common_download_appDownloadReducer__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_businessListReducer__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_homeReducer__ = __webpack_require__(5836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_welcomeReducer__ = __webpack_require__(5837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_serviceAreaMapReducer__ = __webpack_require__(5838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_performanceReducer__ = __webpack_require__(5839);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









/* harmony default export */ __webpack_exports__["default"] = ({
  beforeConfigureStore: function beforeConfigureStore(options) {
    var ionOptions = {
      reducers: _objectSpread(_objectSpread({}, (options || {}).reducers), {}, {
        appDownload: __WEBPACK_IMPORTED_MODULE_3__app_common_download_appDownloadReducer__["a" /* default */],
        businessList: __WEBPACK_IMPORTED_MODULE_4__common_businessListReducer__["a" /* default */],
        home: __WEBPACK_IMPORTED_MODULE_5__common_homeReducer__["a" /* default */],
        performance: __WEBPACK_IMPORTED_MODULE_8__common_performanceReducer__["a" /* default */],
        poller: __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform_lib_common_poller_pollerReducer___default.a,
        welcome: __WEBPACK_IMPORTED_MODULE_6__common_welcomeReducer__["a" /* default */],
        serviceAreaMap: __WEBPACK_IMPORTED_MODULE_7__common_serviceAreaMapReducer__["a" /* default */]
      })
    };
    ionOptions.reducers.home.persist = true;
    return ionOptions;
  },
  afterConfigureStore: function afterConfigureStore(store) {
    if (true) {
      store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform_lib_common_poller_pollerActions__["getConfig"])());
    }
  }
});

/***/ }),

/***/ 5833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(3));

var _get2 = _interopRequireDefault(__webpack_require__(6));

var _pollerActionKeys = __webpack_require__(2346);

var _redux = __webpack_require__(39);

var _createReducer4 = _interopRequireDefault(__webpack_require__(181));

var _AsyncRequest = _interopRequireDefault(__webpack_require__(372));

var _Poller = __webpack_require__(5834);

var _createReducer2, _createReducer3;

var _default = (0, _redux.combineReducers)({
  config: _AsyncRequest.default.createReducer(_pollerActionKeys.GET_CONFIG, (0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    var interval = (0, _get2.default)(action, 'payload.body.interval', _Poller.DEFAULT_POLLER_INTERVAL);

    _Poller.poller.setTimer(interval);

    return _AsyncRequest.default.setSuccess(state, action.payload.body);
  })),
  interval: (0, _createReducer4.default)(_Poller.DEFAULT_POLLER_INTERVAL, (0, _defineProperty2.default)({}, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    return (0, _get2.default)(action, 'payload.body.interval');
  })),
  active: (0, _createReducer4.default)(_Poller.poller.isActive(), (_createReducer2 = {}, (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.GET_CONFIG_SUCCESS, function (state, action) {
    return true;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.START_POLLING, function (state, action) {
    return true;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.STOP_ALL_POLLING, function (state, action) {
    return false;
  }), (0, _defineProperty2.default)(_createReducer2, _pollerActionKeys.STOP_POLLING, function (state, action) {
    return _Poller.poller.isActive();
  }), _createReducer2), false),
  poller: (0, _createReducer4.default)({}, (_createReducer3 = {}, (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.START_POLLING, function (state, action) {
    var callback = action.payload;

    _Poller.poller.start(callback);

    return state;
  }), (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.STOP_POLLING, function (state, action) {
    var callbackId = action.payload;

    _Poller.poller.stop(callbackId);

    return state;
  }), (0, _defineProperty2.default)(_createReducer3, _pollerActionKeys.STOP_ALL_POLLING, function (state, action) {
    _Poller.poller.endPolling();

    return state;
  }), _createReducer3), false)
});

exports.default = _default;
module.exports = exports.default;

/***/ }),

/***/ 5834:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.poller = exports.default = exports.Poller = exports.DEFAULT_POLLER_INTERVAL = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(11));

var _createClass2 = _interopRequireDefault(__webpack_require__(12));

var _isUndefined2 = _interopRequireDefault(__webpack_require__(146));

var _isFinite2 = _interopRequireDefault(__webpack_require__(5835));

var _isFunction2 = _interopRequireDefault(__webpack_require__(174));

var DEFAULT_POLLER_INTERVAL = 60000;
exports.DEFAULT_POLLER_INTERVAL = DEFAULT_POLLER_INTERVAL;

var Poller = /*#__PURE__*/function () {
  function Poller() {
    (0, _classCallCheck2.default)(this, Poller);
    this.intervalRegistry = [];
    this.TIMER = DEFAULT_POLLER_INTERVAL;
  }

  (0, _createClass2.default)(Poller, [{
    key: "_runCallback",
    value: function _runCallback(registeredCallback) {
      return (0, _isFunction2.default)(registeredCallback) ? registeredCallback() : undefined;
    }
  }, {
    key: "_runAll",
    value: function _runAll() {
      this.intervalRegistry.forEach(this._runCallback);
    }
  }, {
    key: "_beginPolling",
    value: function _beginPolling() {
      var _this = this;

      this.interval = setInterval(function () {
        return _this._runAll();
      }, this.TIMER);
    }
  }, {
    key: "_togglePolling",
    value: function _togglePolling() {
      if (this.intervalRegistry.length && !this.interval) {
        this._beginPolling();
      } else if (this.intervalRegistry.length === 0 && this.interval) {
        this.endPolling();
      }
    }
  }, {
    key: "endPolling",
    value: function endPolling() {
      this.intervalRegistry = [];
      this.interval = clearInterval(this.interval);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.intervalRegistry.length > 0;
    }
  }, {
    key: "start",
    value: function start(intervalCallback) {
      // Check to see that FN is not already in registry
      if (this.intervalRegistry.indexOf(intervalCallback) === -1 && (0, _isFunction2.default)(intervalCallback)) {
        this.intervalRegistry.push(intervalCallback);

        this._togglePolling();
      }

      return this.isActive();
    }
  }, {
    key: "stop",
    value: function stop(intervalCallbackId) {
      if ((0, _isFunction2.default)(intervalCallbackId)) {
        this.intervalRegistry = this.intervalRegistry.filter(function (cb) {
          return cb !== intervalCallbackId;
        });

        this._togglePolling();
      }

      return this.isActive();
    }
  }, {
    key: "setTimer",
    value: function setTimer(interval) {
      if ((0, _isFinite2.default)(parseInt(interval, 10))) {
        this.TIMER = interval;
      } // If new value is set, restart poller.


      if (!(0, _isUndefined2.default)(this.interval)) {
        clearInterval(this.interval);

        this._beginPolling();
      }

      return this.isActive();
    }
  }]);
  return Poller;
}();

exports.Poller = Poller;
var poller = new Poller();
exports.poller = poller;
var _default = poller;
exports.default = _default;

/***/ }),

/***/ 5835:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(246);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite;

/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */
function isFinite(value) {
  return typeof value == 'number' && nativeIsFinite(value);
}

module.exports = isFinite;


/***/ }),

/***/ 5836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__homeActionKeys__ = __webpack_require__(2542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_common_user_userActionKeys__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__homeActions__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__ = __webpack_require__(229);









var viewedWelcomeModal = Object(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["createReducer"])(new __WEBPACK_IMPORTED_MODULE_4_immutable___default.a.Map(), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].MARK_MODAL_SEEN, function (state, action) {
  return state.set(action.payload.spid, true);
}), true);
var sentHomePageVisitEvent = Object(__WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["createReducer"])(false, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_6__app_common_user_userActionKeys__["a" /* default */].GET_USER_SUCCESS, function (state, action) {
  if (!state) {
    action.addSideEffect(function (store) {
      store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__homeActions__["sendHomePageVisitEvent"])());
    });
    return true;
  }

  return state;
}));
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux__["combineReducers"])({
  viewedWelcomeModal: viewedWelcomeModal,
  sentHomePageVisitEvent: sentHomePageVisitEvent,
  getAllHighlights: __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].GET_ALL_HIGHLIGHTS),
  updateBusinessHighlights: __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].UPDATE_BUSINESS_HIGHLIGHTS, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5__homeActionKeys__["a" /* default */].UPDATE_BUSINESS_HIGHLIGHTS_SUCCESS, function (state, action) {
    action.addSideEffect(function (store) {
      var storeState = store.getState();

      var serviceProviderId = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(storeState, 'serviceProviderId');

      store.dispatch(__WEBPACK_IMPORTED_MODULE_8__app_common_serviceProvider_serviceProviderActions__["default"].getServiceProvider(serviceProviderId));
    });
    return __WEBPACK_IMPORTED_MODULE_2_angieslist_app_platform__["AsyncRequest"].setSuccess(state, action.payload);
  }))
}));

/***/ }),

/***/ 5837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_common_categories_categoriesActionKeys__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__welcomeActionKeys__ = __webpack_require__(2536);




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  updateBusinessDescription: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_3__welcomeActionKeys__["a" /* default */].UPDATE_BUSINESS_DESCRIPTION),
  categoriesToAdd: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_categories_categoriesActionKeys__["a" /* default */].ADD_CATEGORIES_TO_SERVICE_PROVIDER),
  serviceProviderCategories: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_categories_categoriesActionKeys__["a" /* default */].GET_SERVICE_PROVIDER_CATEGORIES)
}));

/***/ }),

/***/ 5838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__ = __webpack_require__(1547);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  citySearch: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__["a" /* default */].SEARCH_CITIES),
  cityDetails: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__["a" /* default */].GET_CITY_DETAILS),
  setServiceArea: __WEBPACK_IMPORTED_MODULE_1_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__app_common_service_area_serviceAreaMapActionKeys__["a" /* default */].SET_SERVICE_AREA)
}));

/***/ }),

/***/ 5839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export contactMetrics */
/* unused harmony export contactMetricsByCategory */
/* unused harmony export callLog */
/* unused harmony export customerAttributes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__ = __webpack_require__(2547);



var contactMetrics = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CONTACT_METRICS_BY_SERVICE_PROVIDER);
var contactMetricsByCategory = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CONTACT_METRICS_CATEGORY_GROUPS_BY_SERVICE_PROVIDER);
var callLog = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CALL_LOG_BY_SERVICE_PROVIDER);
var customerAttributes = __WEBPACK_IMPORTED_MODULE_0_angieslist_app_platform__["AsyncRequest"].createReducer(__WEBPACK_IMPORTED_MODULE_2__performanceActionKeys__["a" /* default */].GET_CUSTOMER_ATTRIBUTES_BY_UUID);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])({
  contactMetrics: contactMetrics,
  contactMetricsByCategory: contactMetricsByCategory,
  callLog: callLog,
  customerAttributes: customerAttributes
}));

/***/ })

},[5673]);


// WEBPACK FOOTER //
// home-1e560bf9fe4ba1736f5b.js